/**
 * API 路由定义 - v1 版本
 *
 * @generated 由后端脚本自动生成，请勿手动修改
 * @generated-at 2026-01-23 03:13:10
 * @generator backend/app/Console/Commands/ExportApiRoutes.php
 * @version v1
 *
 * ⚠️ 警告：
 * - 此文件由后端脚本自动生成，请勿手动修改
 * - 如需更新路由，请修改后端路由定义后重新运行导出脚本
 * - 导出命令：cd backend && php artisan api:export
 */

/**
 * v1 版本配置
 */
export const API_V1_CONFIG = {
  version: 'v1',
  prefix: '/api',
  fullPrefix: '/api/v1',
  baseUrl: 'http://localhost/api/v1',
} as const

/**
 * v1 版本路由定义
 *
 * 使用示例：
 * ```typescript
 * import { API_V1_ROUTES } from '@bayes-mes/shared/api/routes/v1'
 *
 * // 获取完整路径
 * const path = API_V1_ROUTES.user.list;  // '/api/v1/users'
 *
 * // 函数式路由
 * const detailPath = API_V1_ROUTES.user.detail(123);  // '/api/v1/users/123'
 * ```
 */
export const API_V1_ROUTES = {
  // ========== Andon ==========
  andon: {
    dashboard: '/api/v1/andon/dashboard',
    dashboardAlerts: '/api/v1/andon/dashboard/alerts',
  },

  // ========== AndonBinding ==========
  andonBinding: {
    list: '/api/v1/andon/bindings',
    find: '/api/v1/andon/bindings/find',
    detail: (id: string | number) => `/api/v1/andon/bindings/${id}`,
    create: '/api/v1/andon/bindings',
    bindMatching: '/api/v1/andon/bindings/bind-matching',
    update: (id: string | number) => `/api/v1/andon/bindings/${id}`,
    delete: (id: string | number) => `/api/v1/andon/bindings/${id}`,
  },

  // ========== AndonCall ==========
  andonCall: {
    list: '/api/v1/andon/calls',
    my: '/api/v1/andon/calls/my',
    pending: '/api/v1/andon/calls/pending',
    detail: (id: string | number) => `/api/v1/andon/calls/${id}`,
    create: '/api/v1/andon/calls',
    respond: (id: string | number) => `/api/v1/andon/calls/${id}/respond`,
    complete: (id: string | number) => `/api/v1/andon/calls/${id}/complete`,
    cancel: (id: string | number) => `/api/v1/andon/calls/${id}/cancel`,
  },

  // ========== AndonDevice ==========
  andonDevice: {
    list: '/api/v1/andon/devices',
    detail: (id: string | number) => `/api/v1/andon/devices/${id}`,
    create: '/api/v1/andon/devices',
    syncFromEquipment: '/api/v1/andon/devices/sync-from-equipment',
    update: (id: string | number) => `/api/v1/andon/devices/${id}`,
    delete: (id: string | number) => `/api/v1/andon/devices/${id}`,
  },

  andonCallType: {
    list: '/api/v1/andon/call-types',
    create: '/api/v1/andon/call-types',
    update: (id: string | number) => `/api/v1/andon/call-types/${id}`,
    delete: (id: string | number) => `/api/v1/andon/call-types/${id}`,
  },

  // ========== AndonNotificationConfig（呼叫接收人配置，按类型独立） ==========
  andonNotificationConfig: {
    list: '/api/v1/andon/notification-config',
    update: (typeCode: string) => `/api/v1/andon/notification-config/${typeCode}`,
    rules: '/api/v1/andon/notification-rules',
  },

  // ========== AndonStatistic ==========
  andonStatistic: {
    list: '/api/v1/andon/statistics/today',
    statisticsByType: '/api/v1/andon/statistics/by-type',
    statisticsByWorkstation: '/api/v1/andon/statistics/by-workstation',
    statisticsByLine: '/api/v1/andon/statistics/by-line',
    trend: '/api/v1/andon/statistics/trend',
    statisticsByPerson: '/api/v1/andon/statistics/by-person',
    export: '/api/v1/andon/statistics/export',
  },

  // ========== App ==========
  app: {
    checkVersion: '/api/v1/app/version/check',
    logUpdate: '/api/v1/app/version/log-update',
  },

  // ========== AppLog ==========
  appLog: {
    prefix: '/api/v1/app-logs',
    batch: '/api/v1/app-logs/performance/batch',
    errorsBatch: '/api/v1/app-logs/errors/batch',
    journeyBatch: '/api/v1/app-logs/journey/batch',
    list: '/api/v1/app-logs/performance',
    errors: '/api/v1/app-logs/errors',
    journey: '/api/v1/app-logs/journey',
    statistics: '/api/v1/app-logs/performance/statistics',
    scannerStatistics: '/api/v1/app-logs/performance/scanner-statistics',
    errorsStatistics: '/api/v1/app-logs/errors/statistics',
    journeyStatistics: '/api/v1/app-logs/journey/statistics',
    health: '/api/v1/app-logs/health',
    traces: '/api/v1/app-logs/traces',
    apiStatistics: '/api/v1/app-logs/api/statistics',
    apiDetail: '/api/v1/app-logs/api/detail',
    users: '/api/v1/app-logs/users',
    usersProfile: (userId: string | number) => `/api/v1/app-logs/users/${userId}/profile`,
    usersTimeline: (userId: string | number) => `/api/v1/app-logs/users/${userId}/timeline`,
    alertDetail: (id: string | number) => `/api/v1/app-logs/alerts/${id}`,
    devices: '/api/v1/app-logs/devices',
    devicesProfile: (deviceId: string | number) => `/api/v1/app-logs/devices/${deviceId}/profile`,
    devicesTimeline: (deviceId: string | number) => `/api/v1/app-logs/devices/${deviceId}/timeline`,
    alerts: '/api/v1/app-logs/alerts',
    summary: '/api/v1/app-logs/alerts/summary',
    detect: '/api/v1/app-logs/alerts/detect',
    batchHandle: '/api/v1/app-logs/alerts/batch-handle',
    handleAlert: (id: string | number) => `/api/v1/app-logs/alerts/${id}/handle`,
    funnelList: '/api/v1/app-logs/funnel/list',
    funnelAnalysis: '/api/v1/app-logs/funnel/analysis',
    funnelInterruptions: '/api/v1/app-logs/funnel/interruptions',
    funnel: '/api/v1/app-logs/funnel',
    appLogsFunnel: (id: string | number) => `/api/v1/app-logs/funnel/${id}`,
    delete: (id: string | number) => `/api/v1/app-logs/funnel/${id}`,
  },

  // ========== Audit ==========
  audit: {
    base: '/api/v1/audit',
    list: '/api/v1/audit/logs',
    detail: (id: string | number) => `/api/v1/audit/logs/${id}`,
    stats: '/api/v1/audit/stats',
    trend: '/api/v1/audit/trend',
    modules: '/api/v1/audit/modules',
    actions: '/api/v1/audit/actions',
    export: '/api/v1/audit/logs/export',
    objectHistory: '/api/v1/audit/object-history',
  },

  // ========== Auth ==========
  auth: {
    rememberPasswordPolicy: '/api/v1/auth/remember-password-policy',
    login: '/api/v1/auth/login',
    logout: '/api/v1/auth/logout',
    refresh: '/api/v1/auth/refresh',
    refreshToken: '/api/v1/auth/refresh-token',
    me: '/api/v1/auth/me',
    updateProfile: '/api/v1/auth/me',
    permissions: '/api/v1/auth/permissions',
    changePassword: '/api/v1/auth/change-password',
  },

  // ========== Bom ==========
  bom: {
    list: '/api/v1/boms',
    itemsBase: '/api/v1/bom-items',
    statistics: '/api/v1/boms/statistics',
    tree: '/api/v1/boms/tree',
    findByCode: (code: string | number) => `/api/v1/boms/code/${code}`,
    create: '/api/v1/boms',
    detail: (id: string | number) => `/api/v1/boms/${id}`,
    bomsStatistics: (id: string | number) => `/api/v1/boms/${id}/statistics`,
    boms: (id: string | number) => `/api/v1/boms/${id}`,
    delete: (id: string | number) => `/api/v1/boms/${id}`,
    setDefault: (id: string | number) => `/api/v1/boms/${id}/set-default`,
    batchDelete: '/api/v1/boms/batch-delete',
    import: '/api/v1/boms/import',
    addItem: (id: string | number) => `/api/v1/boms/${id}/items`,
    expand: (id: string | number) => `/api/v1/boms/${id}/expand`,
    bomsTree: (id: string | number) => `/api/v1/boms/${id}/tree`,
    cost: (id: string | number) => `/api/v1/boms/${id}/cost`,
    checkStock: (id: string | number) => `/api/v1/boms/${id}/check-stock`,
    approveApplication: (id: string | number) => `/api/v1/boms/${id}/approve`,
    freeze: (id: string | number) => `/api/v1/boms/${id}/freeze`,
    obsolete: (id: string | number) => `/api/v1/boms/${id}/obsolete`,
    copy: (id: string | number) => `/api/v1/boms/${id}/copy`,
    bomItems: (id: string | number) => `/api/v1/bom-items/${id}`,
    substitutes: (substituteId: string | number) => `/api/v1/substitutes/${substituteId}`,
    addSubstitute: (bomItemId: string | number) => `/api/v1/bom-items/${bomItemId}/substitutes`,
    recommend: (bomItemId: string | number) => `/api/v1/bom-items/${bomItemId}/substitutes/recommend`,
    costComparison: (bomItemId: string | number) => `/api/v1/bom-items/${bomItemId}/substitutes/cost-comparison`,
    batchPriority: (bomItemId: string | number) => `/api/v1/bom-items/${bomItemId}/substitutes/batch-priority`,
    update: (substituteId: string | number) => `/api/v1/substitutes/${substituteId}/priority`,
  },

  // ========== CustomerMaterialSupplier ==========
  customerMaterialSupplier: {
    list: '/api/v1/customer-material-suppliers',
    create: '/api/v1/customer-material-suppliers',
    batchToggleStatus: '/api/v1/customer-material-suppliers/batch-toggle-status',
    byCustomer: (customerId: string | number) =>
      `/api/v1/sales/customers/${customerId}/material-suppliers`,
    bySupplier: (supplierId: string | number) =>
      `/api/v1/purchase/suppliers/${supplierId}/designated-by`,
    detail: (id: string | number) => `/api/v1/customer-material-suppliers/${id}`,
    customerMaterialSuppliers: (id: string | number) => `/api/v1/customer-material-suppliers/${id}`,
    delete: (id: string | number) => `/api/v1/customer-material-suppliers/${id}`,
  },

  // ========== Department ==========
  department: {
    all: '/api/v1/departments/all',
    tree: '/api/v1/departments/tree',
    statistics: '/api/v1/departments/statistics',
    syncWework: '/api/v1/departments/sync-wework',
    list: '/api/v1/departments',
    create: '/api/v1/departments',
    detail: (id: string | number) => `/api/v1/departments/${id}`,
    departments: (id: string | number) => `/api/v1/departments/${id}`,
    delete: (id: string | number) => `/api/v1/departments/${id}`,
  },

  // ========== Employee ==========
  employee: {
    all: '/api/v1/employees/all',
    active: '/api/v1/employees/active',
    statistics: '/api/v1/employees/statistics',
    syncWework: '/api/v1/employees/sync-wework',
    blacklist: '/api/v1/employees/blacklist',
    batchAdd: '/api/v1/employees/blacklist/batch-add',
    batchRemove: '/api/v1/employees/blacklist/batch-remove',
    batchResign: '/api/v1/employees/batch-resign',
    batchRegularize: '/api/v1/employees/batch-regularize',
    batchDelete: '/api/v1/employees/batch-delete',
    availableUsers: '/api/v1/employees/available-users',
    list: '/api/v1/employees',
    create: '/api/v1/employees',
    detail: (id: string | number) => `/api/v1/employees/${id}`,
    employees: (id: string | number) => `/api/v1/employees/${id}`,
    delete: (id: string | number) => `/api/v1/employees/${id}`,
    employeesBlacklist: (id: string | number) => `/api/v1/employees/${id}/blacklist`,
    resign: (id: string | number) => `/api/v1/employees/${id}/resign`,
    regularize: (id: string | number) => `/api/v1/employees/${id}/regularize`,
    linkUser: (id: string | number) => `/api/v1/employees/${id}/link-user`,
    unlinkUser: (id: string | number) => `/api/v1/employees/${id}/unlink-user`,
    sendCredentials: (id: string | number) => `/api/v1/employees/${id}/send-credentials`,
  },

  // ========== Equipment ==========
  equipment: {
    list: '/api/v1/equipments',
    create: '/api/v1/equipments',
    equipmentsMy: '/api/v1/equipments/my',
    // 扫码内容直接进路径段，必须编码：钉钉/支付宝小程序对含特殊字符的 URL 直接 fail
    scan: (code: string | number) => `/api/v1/equipments/scan/${encodeURIComponent(String(code))}`,
    export: '/api/v1/equipments/export',
    import: '/api/v1/equipments/import',
    detail: (id: string | number) => `/api/v1/equipments/${id}`,
    equipments: (id: string | number) => `/api/v1/equipments/${id}`,
    delete: (id: string | number) => `/api/v1/equipments/${id}`,
    bindWorkOrder: (id: string | number) => `/api/v1/equipments/${id}/bind-work-order`,
    unbindWorkOrder: (id: string | number) => `/api/v1/equipments/${id}/unbind-work-order`,
    bindOperator: (id: string | number) => `/api/v1/equipments/${id}/bind-operator`,
    unbindOperator: (id: string | number) => `/api/v1/equipments/${id}/unbind-operator`,
    forceUnbindOperator: (id: string | number) => `/api/v1/equipments/${id}/force-unbind-operator`,
    changeOperation: (id: string | number) => `/api/v1/equipments/${id}/change-operation`,
    status: (id: string | number) => `/api/v1/equipments/${id}/status`,
    repairs: '/api/v1/equipment/repairs',
    createRepair: '/api/v1/equipment/repairs',
    scanReport: '/api/v1/equipment/repairs/scan-report',
    equipmentRepairs: (id: string | number) => `/api/v1/equipment/repairs/${id}`,
    updateRepair: (id: string | number) => `/api/v1/equipment/repairs/${id}`,
    deleteRepair: (id: string | number) => `/api/v1/equipment/repairs/${id}`,
    assign: (id: string | number) => `/api/v1/equipment/repairs/${id}/assign`,
    start: (id: string | number) => `/api/v1/equipment/repairs/${id}/start`,
    complete: (id: string | number) => `/api/v1/equipment/repairs/${id}/complete`,
    cancel: (id: string | number) => `/api/v1/equipment/repairs/${id}/cancel`,
    plans: '/api/v1/equipment/maintenance/plans',
    createPlan: '/api/v1/equipment/maintenance/plans',
    maintenancePlans: (id: string | number) => `/api/v1/equipment/maintenance/plans/${id}`,
    updatePlan: (id: string | number) => `/api/v1/equipment/maintenance/plans/${id}`,
    deletePlan: (id: string | number) => `/api/v1/equipment/maintenance/plans/${id}`,
    tasks: '/api/v1/equipment/maintenance/tasks',
    maintenanceTasks: (id: string | number) => `/api/v1/equipment/maintenance/tasks/${id}`,
    execute: (id: string | number) => `/api/v1/equipment/maintenance/tasks/${id}/execute`,
    inspections: '/api/v1/equipment/inspections',
    createInspection: '/api/v1/equipment/inspections',
    equipmentInspections: (id: string | number) => `/api/v1/equipment/inspections/${id}`,
    inspectionTemplates: '/api/v1/equipment/inspection-templates',
    equipmentInspectionTemplates: (id: string | number) => `/api/v1/equipment/inspection-templates/${id}`,
    copy: (id: string | number) => `/api/v1/equipment/inspection-templates/${id}/copy`,
    inspectionChecklists: '/api/v1/equipment/inspection-checklists',
    bind: '/api/v1/equipment/inspection-checklists/bind',
    inspectionChecklistsEquipment: (equipmentId: string | number) => `/api/v1/equipment/inspection-checklists/equipment/${equipmentId}`,
    inspectionChecklistsItems: '/api/v1/equipment/inspection-checklists/items',
    // ========== 设备支持工序管理 ==========
    supportedOperations: (id: string | number) => `/api/v1/equipments/${id}/supported-operations`,
    syncOperations: (id: string | number) => `/api/v1/equipments/${id}/sync-operations`,
    batchSyncOperations: '/api/v1/equipments/batch-sync-operations',
    availableOperations: (id: string | number) => `/api/v1/equipments/${id}/available-operations`,
    // ===== factory.ts 兼容别名 =====
    inspectionTemplateDetail: (id: string | number) => `/api/v1/equipment/inspection-templates/${id}`,
    inspectionTemplateCopy: (id: string | number) => `/api/v1/equipment/inspection-templates/${id}/copy`,
    inspectionChecklistBind: '/api/v1/equipment/inspection-checklists/bind',
    inspectionChecklistsByEquipment: (equipmentId: string | number) => `/api/v1/equipment/inspection-checklists/equipment/${equipmentId}`,
    inspectionChecklistItems: '/api/v1/equipment/inspection-checklists/items',
  },

  // ========== ErrorLogs ==========
  errorLogs: {
    list: '/api/v1/error-logs',
    statistics: '/api/v1/error-logs/statistics',
    trend: '/api/v1/error-logs/trend',
    detail: (id: string | number) => `/api/v1/error-logs/${id}`,
    resolve: (id: string | number) => `/api/v1/error-logs/${id}/resolve`,
    batchResolve: '/api/v1/error-logs/batch-resolve',
    delete: (id: string | number) => `/api/v1/error-logs/${id}`,
    batchDelete: '/api/v1/error-logs/batch-delete',
    cleanup: '/api/v1/error-logs/cleanup',
  },

  // ========== Factory ==========
  factory: {
    list: '/api/v1/factories',
    all: '/api/v1/factories/all',
    default: '/api/v1/factories/default',
    findByCode: (code: string | number) => `/api/v1/factories/code/${code}`,
    create: '/api/v1/factories',
    batchDelete: '/api/v1/factories/batch-delete',
    detail: (id: string | number) => `/api/v1/factories/${id}`,
    factories: (id: string | number) => `/api/v1/factories/${id}`,
    delete: (id: string | number) => `/api/v1/factories/${id}`,
    setDefault: (id: string | number) => `/api/v1/factories/${id}/set-default`,
    statistics: (id: string | number) => `/api/v1/factories/${id}/statistics`,
  },

  // ========== Feedback ==========
  feedback: {
    list: '/api/v1/feedbacks',
    types: '/api/v1/feedbacks/types',
    statuses: '/api/v1/feedbacks/statuses',
    my: '/api/v1/feedbacks/my',
    myDetail: (id: string | number) => `/api/v1/feedbacks/my/${id}`,
    myComment: (id: string | number) => `/api/v1/feedbacks/my/${id}/comment`,
    myResolve: (id: string | number) => `/api/v1/feedbacks/my/${id}/resolve`,
    feedbacksStatuses: '/api/v1/feedbacks/statuses',
    feedbacksMy: '/api/v1/feedbacks/my',
    detail: (id: string | number) => `/api/v1/feedbacks/${id}`,
    comment: (id: string | number) => `/api/v1/feedbacks/my/${id}/comment`,
    resolve: (id: string | number) => `/api/v1/feedbacks/my/${id}/resolve`,
    create: '/api/v1/feedbacks',
    statistics: '/api/v1/feedbacks/statistics',
    feedbacksComments: (id: string | number) => `/api/v1/feedbacks/${id}/comments`,
    comments: (id: string | number) => `/api/v1/feedbacks/${id}/comments`,
    reply: (id: string | number) => `/api/v1/feedbacks/${id}/reply`,
    update: (id: string | number) => `/api/v1/feedbacks/${id}/status`,
    updateStatus: (id: string | number) => `/api/v1/feedbacks/${id}/status`,
    delete: (id: string | number) => `/api/v1/feedbacks/${id}`,
  },

  // ========== File ==========
  file: {
    list: '/api/v1/file/folders',
    tree: '/api/v1/file/folders/tree',
    detail: (id: string | number) => `/api/v1/file/folders/${id}`,
    folders: '/api/v1/file/folders',
    fileFolders: (id: string | number) => `/api/v1/file/folders/${id}`,
    update: (id: string | number) => `/api/v1/file/folders/${id}/move`,
    delete: (id: string | number) => `/api/v1/file/folders/${id}`,
    permissions: (folderId: string | number) => `/api/v1/file/folders/${folderId}/permissions`,
    foldersPermissions: (folderId: string | number) => `/api/v1/file/folders/${folderId}/permissions`,
    permissionsMine: '/api/v1/file/permissions/mine',
    fileFiles: (id: string | number) => `/api/v1/file/files/${id}`,
    preview: (id: string | number) => `/api/v1/file/files/${id}/preview`,
    download: (id: string | number) => `/api/v1/file/files/${id}/download`,
    files: '/api/v1/file/files',
    version: (id: string | number) => `/api/v1/file/files/${id}/version`,
    move: (id: string | number) => `/api/v1/file/files/${id}/move`,
    copy: (id: string | number) => `/api/v1/file/files/${id}/copy`,
    versions: (fileId: string | number) => `/api/v1/file/files/${fileId}/versions`,
    fileVersions: (id: string | number) => `/api/v1/file/versions/${id}`,
    versionsDownload: (id: string | number) => `/api/v1/file/versions/${id}/download`,
    rollback: (id: string | number) => `/api/v1/file/versions/${id}/rollback`,
    fileLogs: '/api/v1/file/logs',
    storageUsage: '/api/v1/file/storage/usage',
    stats: '/api/v1/file/storage/stats',
  },

  // ========== Inventory ==========
  inventory: {
    list: '/api/v1/inventory/init-batches',
    statistics: '/api/v1/inventory/init-batches/statistics',
    initBatches: '/api/v1/inventory/init-batches',
    detail: (id: string | number) => `/api/v1/inventory/init-batches/${id}`,
    inventoryInitBatches: (id: string | number) => `/api/v1/inventory/init-batches/${id}`,
    delete: (id: string | number) => `/api/v1/inventory/init-batches/${id}`,
    initBatchesItems: (id: string | number, itemId: string | number) => `/api/v1/inventory/init-batches/${id}/items/${itemId}`,
    addItem: (id: string | number) => `/api/v1/inventory/init-batches/${id}/items`,
    initBatchesItemsPrint: (id: string | number) => `/api/v1/inventory/init-batches/${id}/items/print`,
    submit: (id: string | number) => `/api/v1/inventory/init-batches/${id}/submit`,
    inventoryStocktaking: (id: string | number) => `/api/v1/inventory/stocktaking/${id}`,
    stocktakingMyTasks: '/api/v1/inventory/stocktaking/my-tasks',
    stocktakingItems: (id: string | number) => `/api/v1/inventory/stocktaking/${id}/items`,
    stocktakingStatistics: (id: string | number) => `/api/v1/inventory/stocktaking/${id}/statistics`,
    stocktakingFindByBatch: (id: string | number) => `/api/v1/inventory/stocktaking/${id}/find-by-batch`,
    stocktaking: '/api/v1/inventory/stocktaking',
    count: (id: string | number, itemId: string | number) => `/api/v1/inventory/stocktaking/${id}/items/${itemId}/count`,
    countByBatch: (id: string | number) => `/api/v1/inventory/stocktaking/${id}/count-by-batch`,
    update: (id: string | number) => `/api/v1/inventory/stocktaking/${id}/complete`,
    cancel: (id: string | number) => `/api/v1/inventory/stocktaking/${id}/cancel`,
    warningStatistics: '/api/v1/inventory/warning/statistics',
    warningLowStock: '/api/v1/inventory/warning/low-stock',
    warningStagnant: '/api/v1/inventory/warning/stagnant',
  },

  // ========== InventoryBatches ==========
  inventoryBatches: {
    list: '/api/v1/inventory/batches',
    all: '/api/v1/inventory/batches/all',
    statistics: '/api/v1/inventory/batches/statistics',
    expiringSoon: '/api/v1/inventory/batches/expiring-soon',
    expired: '/api/v1/inventory/batches/expired',
    materialSummary: '/api/v1/inventory/batches/material-summary',
    // 物料库存「概要」（扫码辅卡用）
    materialDistributionSummary: (materialId: string | number) =>
      `/api/v1/inventory/batches/material/${materialId}/distribution-summary`,
    // 物料库存「分布」详情（分布页用）
    materialDistribution: (materialId: string | number) =>
      `/api/v1/inventory/batches/material/${materialId}/distribution`,
    batchesMaterialInventoryList: '/api/v1/inventory/batches/material-inventory-list',
    batchesPendingInbound: '/api/v1/inventory/batches/pending-inbound',
    batchesPendingInboundCount: '/api/v1/inventory/batches/pending-inbound-count',
    confirmPurchaseInbound: (id: string | number) => `/api/v1/inventory/batches/confirm-purchase-inbound/${id}`,
    batchesFrequentMaterials: '/api/v1/inventory/batches/frequent-materials',
    scanResolve: '/api/v1/inventory/batches/scan-resolve',
    nonBatchDiagnostics: '/api/v1/inventory/batches/non-batch-diagnostics',
    repairNonBatchDiagnostic: '/api/v1/inventory/batches/non-batch-diagnostics/repair',
    findByBatchNo: (batchNo: string | number) => `/api/v1/inventory/batches/batch-no/${batchNo}`,
    batches: '/api/v1/inventory/batches',
    outbound: '/api/v1/inventory/batches/outbound',
    lock: '/api/v1/inventory/batches/lock',
    unlock: '/api/v1/inventory/batches/unlock',
    transfer: '/api/v1/inventory/batches/transfer',
    import: '/api/v1/inventory/batches/import',
    simpleInbound: '/api/v1/inventory/batches/simple-inbound',
    simpleOutbound: '/api/v1/inventory/batches/simple-outbound',
    batchesNonBatchSummary: '/api/v1/inventory/batches/non-batch-summary',
    nonBatchSummary: '/api/v1/inventory/batches/non-batch-summary', // factory.ts 引用的别名
    detail: (id: string | number) => `/api/v1/inventory/batches/${id}`,
    inventoryBatches: (id: string | number) => `/api/v1/inventory/batches/${id}`,
    delete: (id: string | number) => `/api/v1/inventory/batches/${id}`,
    adjust: (id: string | number) => `/api/v1/inventory/batches/${id}/adjust`,
    freeze: (id: string | number) => `/api/v1/inventory/batches/${id}/freeze`,
    unfreeze: (id: string | number) => `/api/v1/inventory/batches/${id}/unfreeze`,
    batchesForce: (id: string | number) => `/api/v1/inventory/batches/${id}/force`,
    // ===== factory.ts 兼容别名 =====
    forceDelete: (id: string | number) => `/api/v1/inventory/batches/${id}/force`,
  },

  // ========== MaterialAssurance 物料保障工作台 ==========
  materialAssurance: {
    workbench: '/api/v1/inventory/material-assurance/workbench',
    settings: '/api/v1/inventory/material-assurance/settings',
    watches: '/api/v1/inventory/material-assurance/watches',
    unwatch: (materialId: string | number) => `/api/v1/inventory/material-assurance/watches/${materialId}`,
    views: '/api/v1/inventory/material-assurance/views',
    view: (id: string | number) => `/api/v1/inventory/material-assurance/views/${id}`,
    notes: '/api/v1/inventory/material-assurance/notes',
    note: (id: string | number) => `/api/v1/inventory/material-assurance/notes/${id}`,
    actions: '/api/v1/inventory/material-assurance/actions',
    todos: '/api/v1/inventory/material-assurance/todos',
    scan: '/api/v1/inventory/material-assurance/scan',
    scanRuns: '/api/v1/inventory/material-assurance/scan-runs',
    scanRun: (id: string | number) => `/api/v1/inventory/material-assurance/scan-runs/${id}`,
    workload: '/api/v1/inventory/material-assurance/workload',
    suggestions: '/api/v1/inventory/material-assurance/suggestions',
    batchActions: '/api/v1/inventory/material-assurance/actions/batch',
    completeAction: (id: string | number) => `/api/v1/inventory/material-assurance/actions/${id}/complete`,
    cancelAction: (id: string | number) => `/api/v1/inventory/material-assurance/actions/${id}/cancel`,
    executeTransferAction: (id: string | number) => `/api/v1/inventory/material-assurance/actions/${id}/execute-transfer`,
  },

  // ========== InventoryTransactions ==========
  inventoryTransactions: {
    list: '/api/v1/inventory/transactions',
    export: '/api/v1/inventory/transactions/export',
    statistics: '/api/v1/inventory/transactions/statistics',
    transactionsMonthlyReport: '/api/v1/inventory/transactions/monthly-report',
    dailySummary: '/api/v1/inventory/transactions/daily-summary',
    dailyTrend: '/api/v1/inventory/transactions/daily-trend',
    batchHistory: (batchNo: string | number) => `/api/v1/inventory/transactions/batch-history/${batchNo}`,
    materialStatistics: '/api/v1/inventory/transactions/material-statistics',
    warehouseStatistics: '/api/v1/inventory/transactions/warehouse-statistics',
    detail: (id: string | number) => `/api/v1/inventory/transactions/${id}`,
    approveApplication: (id: string | number) => `/api/v1/inventory/transactions/${id}/approve`,
    update: (id: string | number) => `/api/v1/inventory/transactions/${id}/update-quantity`,
  },

  // ========== Iot ==========
  iot: {
    list: '/api/v1/iot/vendors',
    vendorsOptions: '/api/v1/iot/vendors/options',
    vendors: '/api/v1/iot/vendors',
    detail: (id: string | number) => `/api/v1/iot/vendors/${id}`,
    iotVendors: (id: string | number) => `/api/v1/iot/vendors/${id}`,
    delete: (id: string | number) => `/api/v1/iot/vendors/${id}`,
    discoveredDevices: '/api/v1/iot/discovered-devices',
    discoveredDevice: (sn: string | number) => `/api/v1/iot/discovered-devices/${sn}`,
    bindDiscoveredDevice: (sn: string | number) => `/api/v1/iot/discovered-devices/${sn}/bind`,
    ignoreDiscoveredDevice: (sn: string | number) => `/api/v1/iot/discovered-devices/${sn}/ignore`,
    devices: '/api/v1/iot/devices',
    iotDevices: (sn: string | number) => `/api/v1/iot/devices/${sn}`,
    data: '/api/v1/iot/devices/batch/data',
    devicesStatus: (sn: string | number) => `/api/v1/iot/devices/${sn}/status`,
    devicesData: (sn: string | number) => `/api/v1/iot/devices/${sn}/data`,
    devicesHistory: (sn: string | number) => `/api/v1/iot/devices/${sn}/history`,
    devicesAlarms: (sn: string | number) => `/api/v1/iot/devices/${sn}/alarms`,
    control: (sn: string | number) => `/api/v1/iot/devices/${sn}/control`,
    iotAlarms: '/api/v1/iot/alarms',
    active: '/api/v1/iot/alarms/active',
    acknowledge: (id: string | number) => `/api/v1/iot/alarms/${id}/acknowledge`,
    ignoreAlert: (id: string | number) => `/api/v1/iot/alarms/${id}/ignore`,
    statisticsOverview: '/api/v1/iot/statistics/overview',
    iotHealth: '/api/v1/iot/health',
  },

  // ========== Logistic ==========
  logistic: {
    list: '/api/v1/logistics/providers',
    providersOptions: '/api/v1/logistics/providers/options',
    providersGenerateCode: '/api/v1/logistics/providers/generate-code',
    providers: '/api/v1/logistics/providers',
    detail: (id: string | number) => `/api/v1/logistics/providers/${id}`,
    logisticsProviders: (id: string | number) => `/api/v1/logistics/providers/${id}`,
    delete: (id: string | number) => `/api/v1/logistics/providers/${id}`,
    update: (id: string | number) => `/api/v1/logistics/providers/${id}/toggle-status`,
    statistics: (id: string | number) => `/api/v1/logistics/providers/${id}/statistics`,
    orders: '/api/v1/logistics/orders',
    ordersStatistics: '/api/v1/logistics/orders/statistics',
    logisticsOrders: (id: string | number) => `/api/v1/logistics/orders/${id}`,
    fromShipment: '/api/v1/logistics/orders/from-shipment',
    ordersStatus: (id: string | number) => `/api/v1/logistics/orders/${id}/status`,
    ordersTracks: (id: string | number) => `/api/v1/logistics/orders/${id}/tracks`,
    tracks: (id: string | number) => `/api/v1/logistics/orders/${id}/tracks`,
    review: (id: string | number) => `/api/v1/logistics/orders/${id}/review`,
    settlements: '/api/v1/logistics/settlements',
    settlementsTemplate: '/api/v1/logistics/settlements/template',
    logisticsSettlements: (id: string | number) => `/api/v1/logistics/settlements/${id}`,
    import: (id: string | number) => `/api/v1/logistics/settlements/${id}/import`,
    confirm: (id: string | number) => `/api/v1/logistics/settlements/${id}/confirm`,
    pay: (id: string | number) => `/api/v1/logistics/settlements/${id}/pay`,
    settlementsItems: (id: string | number) => `/api/v1/logistics/settlements/${id}/items`,
    items: (id: string | number, itemId: string | number) => `/api/v1/logistics/settlements/${id}/items/${itemId}`,
  },

  // ========== Logs ==========
  logs: {
    list: '/api/v1/logs/login',
    stats: '/api/v1/logs/login/stats',
    trend: '/api/v1/logs/login/trend',
    suspicious: '/api/v1/logs/login/suspicious',
    export: '/api/v1/logs/login/export',
  },

  // ========== Material ==========
  material: {
    list: '/api/v1/materials',
    statistics: '/api/v1/materials/statistics',
    categories: '/api/v1/materials/categories',
    findByCode: (code: string | number) => `/api/v1/materials/code/${code}`,
    create: '/api/v1/materials',
    detail: (id: string | number) => `/api/v1/materials/${id}`,
    materialsStatistics: (id: string | number) => `/api/v1/materials/${id}/statistics`,
    batchConversionPreview: (id: string | number) => `/api/v1/materials/${id}/batch-conversion-preview`,
    enableBatchConversion: (id: string | number) => `/api/v1/materials/${id}/enable-batch-conversion`,
    materials: (id: string | number) => `/api/v1/materials/${id}`,
    delete: (id: string | number) => `/api/v1/materials/${id}`,
    units: (id: string | number) => `/api/v1/materials/${id}/units`,
    addUnit: (id: string | number) => `/api/v1/materials/${id}/units`,
    convertUnit: '/api/v1/materials/convert-unit',
    batchDelete: '/api/v1/materials/batch-delete',
    import: '/api/v1/materials/import',
    export: '/api/v1/materials/export',
    materialUnits: (id: string | number) => `/api/v1/material-units/${id}`,
    whereUsed: (materialId: string | number) => `/api/v1/materials/${materialId}/where-used`,
  },

  // ========== Management ==========
  management: {
    reportsDaily: '/api/v1/management/reports/daily',
    reportsMonthly: '/api/v1/management/reports/monthly',
  },

  // ========== MaterialBorrow ==========
  materialBorrow: {
    list: '/api/v1/material-borrows',
    my: '/api/v1/material-borrows/my',
    pending: '/api/v1/material-borrows/pending',
    statistics: '/api/v1/material-borrows/statistics',
    create: '/api/v1/material-borrows',
    detail: (id: string | number) => `/api/v1/material-borrows/${id}`,
    return: (id: string | number) => `/api/v1/material-borrows/${id}/return`,
    confirm: (id: string | number) => `/api/v1/material-borrows/${id}/confirm`,
    rejectApplication: (id: string | number) => `/api/v1/material-borrows/${id}/reject`,
    confirmReturn: (id: string | number) => `/api/v1/material-borrows/${id}/confirm-return`,
    rejectReturn: (id: string | number) => `/api/v1/material-borrows/${id}/reject-return`,
  },

  // ========== Notification ==========
  notification: {
    list: '/api/v1/notifications',
    unreadCount: '/api/v1/notifications/unread-count',
    statistics: '/api/v1/notifications/statistics',
    tags: '/api/v1/notifications/tags',
    markRead: '/api/v1/notifications/mark-read',
    markAllRead: '/api/v1/notifications/mark-all-read',
    detail: (id: string | number) => `/api/v1/notifications/${id}`,
    delete: (id: string | number) => `/api/v1/notifications/${id}`,
  },

  // ========== NotificationAdmin ==========
  notificationAdmin: {
    base: '/api/v1/admin/notifications',
    send: '/api/v1/admin/notifications/send',
    broadcast: '/api/v1/admin/notifications/broadcast',
    list: '/api/v1/admin/notification-global-settings',
    // 兼容别名：factory.ts 引用 users 和 departments
    users: '/api/v1/admin/notifications/users',
    departments: '/api/v1/admin/notifications/departments',
    notificationsDepartments: '/api/v1/admin/notifications/departments',
    notificationGlobalSettings: '/api/v1/admin/notification-global-settings',
    sync: '/api/v1/admin/notification-global-settings/sync',
    adminNotificationTemplates: (id: string | number) => `/api/v1/admin/notification-templates/${id}`,
    detail: (id: string | number) => `/api/v1/admin/notification-templates/${id}`,
    notificationTemplates: '/api/v1/admin/notification-templates',
    delete: (id: string | number) => `/api/v1/admin/notification-templates/${id}`,
    test: (id: string | number) => `/api/v1/admin/notification-templates/${id}/test`,
    adminNotificationEventLogs: '/api/v1/admin/notification-event-logs',
    statistics: '/api/v1/admin/notification-event-logs/statistics',
    dashboard: '/api/v1/admin/notification-monitor/dashboard',
    notificationMonitorSendRecords: (id: string | number) => `/api/v1/admin/notification-monitor/send-records/${id}`,
    notificationMonitorFailures: '/api/v1/admin/notification-monitor/failures',
    retry: (id: string | number) => `/api/v1/admin/notification-monitor/retry/${id}`,
    batchRetry: '/api/v1/admin/notification-monitor/batch-retry',
    adminNotificationSystemConfig: '/api/v1/admin/notification-system-config',
    masterSwitch: '/api/v1/admin/notification-system-config/master-switch',
    channelSwitch: '/api/v1/admin/notification-system-config/channel-switch',
    rateLimit: '/api/v1/admin/notification-system-config/rate-limit',
    quietHours: '/api/v1/admin/notification-system-config/quiet-hours',
    clearCache: '/api/v1/admin/notification-system-config/clear-cache',
    adminNotificationSystemRules: (id: string | number) => `/api/v1/admin/notification-system-rules/${id}`,
    notificationSystemRulesModule: (module: string | number) => `/api/v1/admin/notification-system-rules/module/${module}`,
    notificationSystemRules: '/api/v1/admin/notification-system-rules',
    batchStatus: '/api/v1/admin/notification-system-rules/batch-status',
    initModule: '/api/v1/admin/notification-system-rules/init-module',
  },

  // ========== NotificationMonitor ==========
  notificationMonitor: {
    dashboard: '/api/v1/admin/notification-monitor/dashboard',
    sendRecords: '/api/v1/admin/notification-monitor/send-records',
    sendRecordDetail: (id: string | number) => `/api/v1/admin/notification-monitor/send-records/${id}`,
    failures: '/api/v1/admin/notification-monitor/failures',
    retry: (id: string | number) => `/api/v1/admin/notification-monitor/retry/${id}`,
    batchRetry: '/api/v1/admin/notification-monitor/batch-retry',
  },

  // ========== NotificationSetting ==========
  notificationSetting: {
    list: '/api/v1/notification-settings',
    master: '/api/v1/notification-settings/master',
    event: (eventType: string | number) => `/api/v1/notification-settings/event/${eventType}`,
    batch: '/api/v1/notification-settings/batch',
    reset: '/api/v1/notification-settings/reset',
    channels: '/api/v1/notification-settings/channels',
  },

  // ========== Oee ==========
  oee: {
    list: '/api/v1/oee/downtime',
    dashboardOverview: '/api/v1/oee/dashboard/overview',
    dashboardEquipments: '/api/v1/oee/dashboard/equipments',
    dashboardEquipmentRealtime: (id: string | number) => `/api/v1/oee/dashboard/equipment/${id}/realtime`,
    detail: (downtime: string | number) => `/api/v1/oee/downtime/${downtime}`,
    trend: '/api/v1/oee/dashboard/trend',
    dashboardLosses: '/api/v1/oee/dashboard/losses',
    dashboardIntegrationStatus: '/api/v1/oee/dashboard/integration-status',
    calculate: '/api/v1/oee/dashboard/calculate',
    syncAndon: '/api/v1/oee/dashboard/sync-andon',
    all: '/api/v1/oee/config/downtime-reasons/all',
    configDowntimeReasons: (downtime_reason: string | number) => `/api/v1/oee/config/downtime-reasons/${downtime_reason}`,
    downtimeReasons: '/api/v1/oee/config/downtime-reasons',
    delete: (downtime_reason: string | number) => `/api/v1/oee/config/downtime-reasons/${downtime_reason}`,
    plannedTimeEffective: '/api/v1/oee/config/planned-time/effective',
    configPlannedTime: (planned_time: string | number) => `/api/v1/oee/config/planned-time/${planned_time}`,
    plannedTime: '/api/v1/oee/config/planned-time',
    cycleTimeEffective: '/api/v1/oee/config/cycle-time/effective',
    configCycleTime: (cycle_time: string | number) => `/api/v1/oee/config/cycle-time/${cycle_time}`,
    cycleTime: '/api/v1/oee/config/cycle-time',
    downtimePending: '/api/v1/oee/downtime/pending',
    statistics: '/api/v1/oee/downtime/statistics',
    end: (id: string | number) => `/api/v1/oee/downtime/${id}/end`,
    verify: (id: string | number) => `/api/v1/oee/downtime/${id}/verify`,
    downtime: '/api/v1/oee/downtime',
    oeeDowntime: (downtime: string | number) => `/api/v1/oee/downtime/${downtime}`,
  },

  // ========== Operation ==========
  operation: {
    list: '/api/v1/operations',
    all: '/api/v1/operations/all',
    statistics: '/api/v1/operations/statistics',
    types: '/api/v1/operations/types',
    inspectionTypes: '/api/v1/operations/inspection-types',
    findByCode: (code: string | number) => `/api/v1/operations/code/${code}`,
    create: '/api/v1/operations',
    batchDelete: '/api/v1/operations/batch-delete',
    import: '/api/v1/operations/import',
    export: '/api/v1/operations/export',
    template: '/api/v1/operations/template',
    detail: (id: string | number) => `/api/v1/operations/${id}`,
    operationsStatistics: (id: string | number) => `/api/v1/operations/${id}/statistics`,
    operations: (id: string | number) => `/api/v1/operations/${id}`,
    delete: (id: string | number) => `/api/v1/operations/${id}`,
    update: (id: string | number) => `/api/v1/operations/${id}/status`,
  },

  // ========== Permission ==========
  permission: {
    list: '/api/v1/permissions',
    create: '/api/v1/permissions',
    modules: '/api/v1/permissions/modules',
    tree: '/api/v1/permissions/tree',
    batchCrud: '/api/v1/permissions/batch-crud',
    cacheStatus: '/api/v1/permissions/cache/status',
    refresh: '/api/v1/permissions/cache/refresh',
    refreshUser: '/api/v1/permissions/cache/refresh-user',
    syncSuperAdmin: '/api/v1/permissions/cache/sync-super-admin',
    detail: (permission: string | number) => `/api/v1/permissions/${permission}`,
    permissions: (permission: string | number) => `/api/v1/permissions/${permission}`,
    delete: (permission: string | number) => `/api/v1/permissions/${permission}`,
    // ===== factory.ts 兼容别名 =====
    cacheRefresh: '/api/v1/permissions/cache/refresh',
    cacheRefreshUser: '/api/v1/permissions/cache/refresh-user',
    cacheSyncSuperAdmin: '/api/v1/permissions/cache/sync-super-admin',
  },

  // ========== PickingStatistic ==========
  pickingStatistic: {
    list: '/api/v1/picking-statistics/picking-records',
    pickingByPerson: '/api/v1/picking-statistics/picking/by-person',
    pickingByMaterial: '/api/v1/picking-statistics/picking/by-material',
    trend: '/api/v1/picking-statistics/picking/trend',
    borrowByPerson: '/api/v1/picking-statistics/borrow/by-person',
    borrowByMaterial: '/api/v1/picking-statistics/borrow/by-material',
    borrowTrend: '/api/v1/picking-statistics/borrow/trend',
  },

  // ========== Planning ==========
  planning: {
    orderFulfillment: '/api/v1/planning/order-fulfillment',
    orderFulfillmentDetail: (id: string | number) => `/api/v1/planning/order-fulfillment/${id}`,
    calculate: '/api/v1/planning/mrp/calculate',
    calculateBatch: '/api/v1/planning/mrp/calculate-batch',
    calculateForOrder: (id: string | number) => `/api/v1/planning/mrp/calculate-for-order/${id}`,
    suggestions: '/api/v1/planning/mrp/suggestions',
    detail: (id: string | number) => `/api/v1/planning/kit/check-work-order/${id}`,
    kitCheckBom: (id: string | number) => `/api/v1/planning/kit/check-bom/${id}`,
    checkBatch: '/api/v1/planning/kit/check-batch',
    checkAggregated: '/api/v1/planning/kit/check-aggregated',
    checkByPlan: '/api/v1/planning/kit/check-by-plan',
  },

  // ========== Pricing ==========
  pricing: {
    list: '/api/v1/pricing/configs',
    statistics: '/api/v1/pricing/configs/statistics',
    configs: '/api/v1/pricing/configs',
    detail: (id: string | number) => `/api/v1/pricing/configs/${id}`,
    pricingConfigs: (id: string | number) => `/api/v1/pricing/configs/${id}`,
    delete: (id: string | number) => `/api/v1/pricing/configs/${id}`,
    update: (id: string | number) => `/api/v1/pricing/configs/${id}/enable`,
    configsDisable: (id: string | number) => `/api/v1/pricing/configs/${id}/disable`,
    configsHistory: (materialId: string | number) => `/api/v1/pricing/configs/${materialId}/history`,
    availableMaterials: '/api/v1/pricing/configs/available-materials',
    pricesCurrent: '/api/v1/pricing/prices/current',
    pricesHistory: '/api/v1/pricing/prices/history',
    export: '/api/v1/pricing/prices/export',
    pricesByConfig: (configId: string | number) => `/api/v1/pricing/prices/by-config/${configId}`,
    batch: '/api/v1/pricing/prices/batch',
    import: '/api/v1/pricing/prices/import',
    pricingPrices: (id: string | number) => `/api/v1/pricing/prices/${id}`,
    prices: '/api/v1/pricing/prices',
    wages: '/api/v1/pricing/wages',
    wagesExport: '/api/v1/pricing/wages/export',
    wagesFinanceLedger: '/api/v1/pricing/wages/finance-ledger',
    batchConfirm: '/api/v1/pricing/wages/batch-confirm',
    batchSettle: '/api/v1/pricing/wages/batch-settle',
    pricingWages: (id: string | number) => `/api/v1/pricing/wages/${id}`,
    wagesUser: (userId: string | number) => `/api/v1/pricing/wages/user/${userId}`,
    confirm: (id: string | number) => `/api/v1/pricing/wages/${id}/confirm`,
    settle: (id: string | number) => `/api/v1/pricing/wages/${id}/settle`,
    void: (id: string | number) => `/api/v1/pricing/wages/${id}/void`,
    wagesSyncCurrentPrices: '/api/v1/pricing/wages/sync-current-prices',
    dashboard: '/api/v1/pricing/statistics/dashboard',
    statisticsByUser: '/api/v1/pricing/statistics/by-user',
    statisticsByMaterial: '/api/v1/pricing/statistics/by-material',
    statisticsByOperation: '/api/v1/pricing/statistics/by-operation',
    statisticsByDay: '/api/v1/pricing/statistics/by-day',
    statisticsByWeek: '/api/v1/pricing/statistics/by-week',
    statisticsByMonth: '/api/v1/pricing/statistics/by-month',
    statisticsByYear: '/api/v1/pricing/statistics/by-year',
  },

  // ========== PrintLog ==========
  printLog: {
    list: '/api/v1/print-logs',
    create: '/api/v1/print-logs',
    detail: (id: string | number) => `/api/v1/print-logs/${id}`,
  },

  // ========== PrintTemplate ==========
  printTemplate: {
    list: '/api/v1/print-templates',
    version: '/api/v1/print-templates/version',
    create: '/api/v1/print-templates',
    detail: (id: string | number) => `/api/v1/print-templates/${id}`,
    printTemplates: (id: string | number) => `/api/v1/print-templates/${id}`,
    delete: (id: string | number) => `/api/v1/print-templates/${id}`,
    setDefault: (id: string | number) => `/api/v1/print-templates/${id}/set-default`,
  },

  // ========== Printer ==========
  printer: {
    list: '/api/v1/printers',
    create: '/api/v1/printers',
    detail: (id: string | number) => `/api/v1/printers/${id}`,
    printers: (id: string | number) => `/api/v1/printers/${id}`,
    delete: (id: string | number) => `/api/v1/printers/${id}`,
  },

  // ========== ProcessOperations ==========
  processOperations: {
    list: '/api/v1/process-operations',
    statistics: '/api/v1/process-operations/statistics',
    all: '/api/v1/process-operations/all',
    byRoute: (routeId: string | number) => `/api/v1/process-operations/route/${routeId}`,
    findByCode: (routeId: string | number, code: string | number) => `/api/v1/process-operations/route/${routeId}/code/${code}`,
    detail: (id: string | number) => `/api/v1/process-operations/${id}`,
    create: '/api/v1/process-operations',
    batchDelete: '/api/v1/process-operations/batch-delete',
    batchImport: '/api/v1/process-operations/batch-import',
    reorder: '/api/v1/process-operations/reorder',
    processOperationsStatistics: (id: string | number) => `/api/v1/process-operations/${id}/statistics`,
    processOperations: (id: string | number) => `/api/v1/process-operations/${id}`,
    delete: (id: string | number) => `/api/v1/process-operations/${id}`,
    prevOperations: (id: string | number) => `/api/v1/process-operations/${id}/prev-operations`,
    nextOperations: (id: string | number) => `/api/v1/process-operations/${id}/next-operations`,
    flow: (id: string | number) => `/api/v1/process-operations/${id}/flow`,
    duplicate: (id: string | number) => `/api/v1/process-operations/${id}/duplicate`,
    update: (id: string | number) => `/api/v1/process-operations/${id}/status`,
    calculateOutput: (id: string | number) => `/api/v1/process-operations/${id}/calculate-output`,
    calculateRequiredInput: (id: string | number) => `/api/v1/process-operations/${id}/calculate-input`,
  },

  // ========== ProcessRoute ==========
  processRoute: {
    list: '/api/v1/process-routes',
    statistics: '/api/v1/process-routes/statistics',
    all: '/api/v1/process-routes/all',
    findByCode: (code: string | number) => `/api/v1/process-routes/code/${code}`,
    detail: (id: string | number) => `/api/v1/process-routes/${id}`,
    create: '/api/v1/process-routes',
    batchDelete: '/api/v1/process-routes/batch-delete',
    import: '/api/v1/process-routes/import',
    processRoutesStatistics: (id: string | number) => `/api/v1/process-routes/${id}/statistics`,
    processRoutes: (id: string | number) => `/api/v1/process-routes/${id}`,
    delete: (id: string | number) => `/api/v1/process-routes/${id}`,
    setDefault: (id: string | number) => `/api/v1/process-routes/${id}/set-default`,
    approveApplication: (id: string | number) => `/api/v1/process-routes/${id}/approve`,
    freeze: (id: string | number) => `/api/v1/process-routes/${id}/freeze`,
    obsolete: (id: string | number) => `/api/v1/process-routes/${id}/obsolete`,
    duplicate: (id: string | number) => `/api/v1/process-routes/${id}/duplicate`,
    recalculate: (id: string | number) => `/api/v1/process-routes/${id}/recalculate`,
  },

  // ========== ProcessRouteTemplate ==========
  processRouteTemplate: {
    list: '/api/v1/process-route-templates',
    active: '/api/v1/process-route-templates/active',
    create: '/api/v1/process-route-templates',
    detail: (id: string | number) => `/api/v1/process-route-templates/${id}`,
    processRouteTemplates: (id: string | number) => `/api/v1/process-route-templates/${id}`,
    delete: (id: string | number) => `/api/v1/process-route-templates/${id}`,
    duplicate: (id: string | number) => `/api/v1/process-route-templates/${id}/duplicate`,
    generate: (id: string | number) => `/api/v1/process-route-templates/${id}/generate`,
    batchGenerate: (id: string | number) => `/api/v1/process-route-templates/${id}/batch-generate`,
    operations: (id: string | number) => `/api/v1/process-route-templates/${id}/operations`,
  },

  // ========== ProcessRouteTemplateOperation ==========
  processRouteTemplateOperation: {
    processRouteTemplateOperations: (id: string | number) => `/api/v1/process-route-template-operations/${id}`,
    delete: (id: string | number) => `/api/v1/process-route-template-operations/${id}`,
  },

  // ========== Production ==========
  production: {
    dashboard: '/api/v1/production/dashboard',
    wipOverview: '/api/v1/production/wip/overview',
    wipRealtimeInventory: '/api/v1/production/wip/realtime-inventory',
    wipBatches: '/api/v1/production/wip/batches',
    wipEquipment: '/api/v1/production/wip/equipment',
    productOperationProgress: '/api/v1/production/product-operation-progress',
    list: '/api/v1/production/orders',
    dashboardRecentReports: '/api/v1/production/dashboard/recent-reports',
    dashboardOutputTrend: '/api/v1/production/dashboard/output-trend',
    dashboardOperationProgress: '/api/v1/production/dashboard/operation-progress',
    dashboardPlanProgress: '/api/v1/production/dashboard/plan-progress',
    dashboardOutputStatistics: '/api/v1/production/dashboard/output-statistics',
    statistics: '/api/v1/production/orders/statistics',
    orders: '/api/v1/production/orders',
    detail: (id: string | number) => `/api/v1/production/orders/${id}`,
    productionOrders: (id: string | number) => `/api/v1/production/orders/${id}`,
    delete: (id: string | number) => `/api/v1/production/orders/${id}`,
    accept: (id: string | number) => `/api/v1/production/orders/${id}/accept`,
    approveApplication: (id: string | number) => `/api/v1/production/orders/${id}/approve`,
    start: (id: string | number) => `/api/v1/production/orders/${id}/start`,
    complete: (id: string | number) => `/api/v1/production/orders/${id}/complete`,
    cancel: (id: string | number) => `/api/v1/production/orders/${id}/cancel`,
    ordersPause: (id: string | number) => `/api/v1/production/orders/${id}/pause`,
    ordersResume: (id: string | number) => `/api/v1/production/orders/${id}/resume`,
    ordersRestore: (id: string | number) => `/api/v1/production/orders/${id}/restore`,
    preview: (id: string | number) => `/api/v1/production/orders/${id}/dispatch/preview`,
    confirm: (id: string | number) => `/api/v1/production/orders/${id}/dispatch/confirm`,
    ordersChangelog: (id: string | number) => `/api/v1/production/orders/${id}/changelog`,
    ordersOperationProgress: (id: string | number) => `/api/v1/production/orders/${id}/operation-progress`,
    workOrdersStatistics: '/api/v1/production/work-orders/statistics',
    workOrdersAvailable: '/api/v1/production/work-orders/available',
    workOrdersAccepted: '/api/v1/production/work-orders/accepted',
    workOrdersByCode: '/api/v1/production/work-orders/by-code',
    generateMultiLevel: '/api/v1/production/work-orders/generate-multi-level',
    productionWorkOrders: (id: string | number) => `/api/v1/production/work-orders/${id}`,
    workOrders: '/api/v1/production/work-orders',
    workOrdersAccept: (id: string | number) => `/api/v1/production/work-orders/${id}/accept`,
    workOrdersStart: (id: string | number) => `/api/v1/production/work-orders/${id}/start`,
    pause: (id: string | number) => `/api/v1/production/work-orders/${id}/pause`,
    workOrdersComplete: (id: string | number) => `/api/v1/production/work-orders/${id}/complete`,
    workOrdersCancel: (id: string | number) => `/api/v1/production/work-orders/${id}/cancel`,
    workOrdersRestore: (id: string | number) => `/api/v1/production/work-orders/${id}/restore`,
    workOrdersOperations: (id: string | number) => `/api/v1/production/work-orders/${id}/operations`,
    workOrdersProgress: (id: string | number) => `/api/v1/production/work-orders/${id}/progress`,
    workOrdersConsumptions: (id: string | number) => `/api/v1/production/work-orders/${id}/consumptions`,
    workOrdersOperationMaterials: (id: string | number) => `/api/v1/production/work-orders/${id}/operation-materials`,
    bindEquipment: (id: string | number) => `/api/v1/production/work-orders/${id}/bind-equipment`,
    printBatchLabel: (id: string | number) => `/api/v1/production/work-orders/${id}/print-batch-label`,
    workOrdersBatchLabels: (id: string | number) => `/api/v1/production/work-orders/${id}/batch-labels`,
    tree: (id: string | number) => `/api/v1/production/work-orders/${id}/tree`,
    workOrdersChildStatus: (id: string | number) => `/api/v1/production/work-orders/${id}/child-status`,
    outputInbound: (id: string | number) => `/api/v1/production/work-orders/${id}/output-inbound`,
    workOrdersAvailableSemi: (id: string | number) => `/api/v1/production/work-orders/${id}/available-semi`,
    consumeSemi: (id: string | number) => `/api/v1/production/work-orders/${id}/consume-semi`,
    // 工单转移相关（2026-02-11 新增）
    workOrdersTransferTargets: (id: string | number) => `/api/v1/production/work-orders/${id}/transfer-targets`,
    workOrdersTransferPreview: (id: string | number) => `/api/v1/production/work-orders/${id}/transfer-preview`,
    workOrdersTransfer: (id: string | number) => `/api/v1/production/work-orders/${id}/transfer`,
    workOrdersTransferHistory: (id: string | number) => `/api/v1/production/work-orders/${id}/transfer-history`,
    workOrdersChangeHistory: (id: string | number) => `/api/v1/production/work-orders/${id}/change-history`,
    workOrdersUpdateRemark: (id: string | number) => `/api/v1/production/work-orders/${id}/remark`,
    // 工序临时变更（v4.0 新增）
    workOrdersAddOperation: (id: string | number) => `/api/v1/production/work-orders/${id}/operations/add`,
    workOrdersRemoveOperation: (id: string | number, workOrderOperationId: string | number) => `/api/v1/production/work-orders/${id}/operations/${workOrderOperationId}/remove`,
    workOrdersSkipOperation: (id: string | number, workOrderOperationId: string | number) => `/api/v1/production/work-orders/${id}/operations/${workOrderOperationId}/skip`,
    workOrdersUnskipOperation: (id: string | number, workOrderOperationId: string | number) => `/api/v1/production/work-orders/${id}/operations/${workOrderOperationId}/unskip`,
    workOrdersReorderOperations: (id: string | number) => `/api/v1/production/work-orders/${id}/operations/reorder`,
    workOrdersUpdateOperationParams: (id: string | number, workOrderOperationId: string | number) => `/api/v1/production/work-orders/${id}/operations/${workOrderOperationId}/update-params`,
    workOrdersOperationChanges: (id: string | number) => `/api/v1/production/work-orders/${id}/operation-changes`,
    // 计划级批量工序变更（v4.0 新增）
    ordersBatchChangeOperations: (id: string | number) => `/api/v1/production/orders/${id}/batch-change-operations`,
    statisticsOperator: '/api/v1/production/work-reports/statistics/operator',
    statisticsWorkstation: '/api/v1/production/work-reports/statistics/workstation',
    statisticsDaily: '/api/v1/production/work-reports/statistics/daily',
    productionWorkReports: (id: string | number) => `/api/v1/production/work-reports/${id}`,
    workReports: '/api/v1/production/work-reports',
    batch: '/api/v1/production/work-reports/batch',
    workReportsCancel: (id: string | number) => `/api/v1/production/work-reports/${id}/cancel`,
    forceCancel: (id: string | number) => `/api/v1/production/work-reports/${id}/force-cancel`,
    // 班长日报（2026-09-19 新增；2026-09-20 增加交接接收与填报辅助；2026-09-21 增加今日汇总与推送开关）
    dailyReportsStatistics: '/api/v1/production/daily-reports/statistics',
    dailyReportsTodaySummary: '/api/v1/production/daily-reports/today-summary',
    dailyReportsNotificationSwitch: '/api/v1/production/daily-reports/notification-switch',
    dailyReportsPreviousHandover: '/api/v1/production/daily-reports/previous-handover',
    dailyReportsDuplicateCheck: '/api/v1/production/daily-reports/duplicate-check',
    productionDailyReports: (id: string | number) => `/api/v1/production/daily-reports/${id}`,
    dailyReportsConfirmHandover: (id: string | number) => `/api/v1/production/daily-reports/${id}/confirm-handover`,
    dailyReports: '/api/v1/production/daily-reports',
    checkBom: '/api/v1/production/material-consumptions/check-bom',
    materialConsumptionsBatch: '/api/v1/production/material-consumptions/batch',
    return: '/api/v1/production/material-consumptions/return',
    productionMaterialConsumptions: (id: string | number) => `/api/v1/production/material-consumptions/${id}`,
    materialConsumptions: '/api/v1/production/material-consumptions',
    // 报废单相关
    productionScrapOrders: (id: string | number) => `/api/v1/production/scrap-orders/${id}`,
    scrapOrders: '/api/v1/production/scrap-orders',
    scrapOrdersApprove: (id: string | number) => `/api/v1/production/scrap-orders/${id}/approve`,
    // 报废单统计
    scrapOrdersStatsSummary: '/api/v1/production/scrap-orders/stats/summary',
    scrapOrdersStatsByType: '/api/v1/production/scrap-orders/stats/by-type',
    scrapOrdersStatsByDisposal: '/api/v1/production/scrap-orders/stats/by-disposal',
    scrapOrdersStatsByMaterial: '/api/v1/production/scrap-orders/stats/by-material',
    scrapOrdersStatsByReason: '/api/v1/production/scrap-orders/stats/by-reason',
    scrapOrdersStatsTrend: '/api/v1/production/scrap-orders/stats/trend',
    // 返工单相关
    productionReworkOrders: (id: string | number) => `/api/v1/production/rework-orders/${id}`,
    reworkOrders: '/api/v1/production/rework-orders',
    reworkOrdersApprove: (id: string | number) => `/api/v1/production/rework-orders/${id}/approve`,
    reworkOrdersStart: (id: string | number) => `/api/v1/production/rework-orders/${id}/start`,
    reworkOrdersComplete: (id: string | number) => `/api/v1/production/rework-orders/${id}/complete`,
    // 返工单统计
    reworkOrdersStatsSummary: '/api/v1/production/rework-orders/stats/summary',
    reworkOrdersStatsByType: '/api/v1/production/rework-orders/stats/by-type',
    reworkOrdersStatsByMaterial: '/api/v1/production/rework-orders/stats/by-material',
    reworkOrdersStatsByReason: '/api/v1/production/rework-orders/stats/by-reason',
    reworkOrdersStatsTrend: '/api/v1/production/rework-orders/stats/trend',
    batchesSearch: '/api/v1/production/batches/search',
    productionBatches: (batchNo: string | number) => `/api/v1/production/batches/${batchNo}`,
    batchesWorkReports: (batchNo: string | number) => `/api/v1/production/batches/${batchNo}/work-reports`,
    labelReprints: (batchNo: string | number) => `/api/v1/production/batches/${batchNo}/label-reprints`,
    containerChanges: (batchNo: string | number) => `/api/v1/production/batches/${batchNo}/container-changes`,
    scrapRateCalculateWorkOrder: (id: string | number) => `/api/v1/production/scrap-rate/calculate-work-order/${id}`,
    calculateRequiredInput: '/api/v1/production/scrap-rate/calculate-required-input',
    scrapRateValidate: (routeId: string | number) => `/api/v1/production/scrap-rate/validate/${routeId}`,
    scrapRateTotalScrapRate: (routeId: string | number) => `/api/v1/production/scrap-rate/total-scrap-rate/${routeId}`,
    capacityLines: '/api/v1/production/capacity/lines',
    // ===== factory.ts 兼容别名 =====
    workOrdersGenerateMultiLevel: '/api/v1/production/work-orders/generate-multi-level',
    workOrdersTree: (id: string | number) => `/api/v1/production/work-orders/${id}/tree`,
    workOrdersOutputInbound: (id: string | number) => `/api/v1/production/work-orders/${id}/output-inbound`,
    workOrdersConsumeSemi: (id: string | number) => `/api/v1/production/work-orders/${id}/consume-semi`,
    workReportsForceCancel: (id: string | number) => `/api/v1/production/work-reports/${id}/force-cancel`,
    // TV 大屏相关（已移到 tv 模块，保留兼容别名）
    tvDashboard: '/api/v1/tv/production/dashboard',
    tvDashboardShiftOutput: '/api/v1/tv/production/dashboard/shift-output',
    tvDashboardRecentReports: '/api/v1/tv/production/dashboard/recent-reports',
    tvDashboardOutputTrend: '/api/v1/tv/production/dashboard/output-trend',
    tvDashboardOperationProgress: '/api/v1/tv/production/dashboard/operation-progress',
    tvDashboardPlanProgress: '/api/v1/tv/production/dashboard/plan-progress',
  },

  // ========== ProductionLine ==========
  productionLine: {
    list: '/api/v1/production-lines',
    all: '/api/v1/production-lines/all',
    findByCode: '/api/v1/production-lines/find-by-code',
    create: '/api/v1/production-lines',
    batchDelete: '/api/v1/production-lines/batch-delete',
    import: '/api/v1/production-lines/import',
    order: '/api/v1/production-lines/order',
    detail: (id: string | number) => `/api/v1/production-lines/${id}`,
    productionLines: (id: string | number) => `/api/v1/production-lines/${id}`,
    delete: (id: string | number) => `/api/v1/production-lines/${id}`,
    statistics: (id: string | number) => `/api/v1/production-lines/${id}/statistics`,
    workstations: (id: string | number) => `/api/v1/production-lines/${id}/workstations`,
    calculateCapacity: (id: string | number) => `/api/v1/production-lines/${id}/calculate-capacity`,
  },

  // ========== Purchase ==========
  purchase: {
    checkDesignatedSupplier: '/api/v1/purchase/check-designated-supplier',
    detail: (id: string | number) => `/api/v1/purchase/suppliers/${id}`,
    list: '/api/v1/purchase/suppliers',
    all: '/api/v1/purchase/suppliers/all',
    active: '/api/v1/purchase/suppliers/active',
    blacklisted: '/api/v1/purchase/suppliers/blacklisted',
    statistics: '/api/v1/purchase/suppliers/statistics',
    suppliers: '/api/v1/purchase/suppliers',
    findByCode: (code: string | number) => `/api/v1/purchase/suppliers/code/${code}`,
    purchaseSuppliers: (id: string | number) => `/api/v1/purchase/suppliers/${id}`,
    delete: (id: string | number) => `/api/v1/purchase/suppliers/${id}`,
    batch: '/api/v1/purchase/suppliers/batch',
    export: '/api/v1/purchase/suppliers/export',
    import: '/api/v1/purchase/suppliers/import',
    suppliersStatistics: (id: string | number) => `/api/v1/purchase/suppliers/${id}/statistics`,
    suppliersMaterials: (id: string | number) => `/api/v1/purchase/suppliers/${id}/materials`,
    materials: (id: string | number) => `/api/v1/purchase/suppliers/${id}/materials`,
    supplierMaterials: (id: string | number) => `/api/v1/purchase/supplier-materials/${id}`,
    purchaseSupplierMaterials: (id: string | number) => `/api/v1/purchase/supplier-materials/${id}`,
    supplierMaterialsHistory: (id: string | number) => `/api/v1/purchase/supplier-materials/${id}/history`,
    purchaseOrders: (id: string | number) => `/api/v1/purchase/orders/${id}`,
    ordersStatistics: '/api/v1/purchase/orders/statistics',
    overdue: '/api/v1/purchase/orders/overdue',
    orders: '/api/v1/purchase/orders',
    approveApplication: (id: string | number) => `/api/v1/purchase/orders/${id}/approve`,
    confirm: (id: string | number) => `/api/v1/purchase/orders/${id}/confirm`,
    cancel: (id: string | number) => `/api/v1/purchase/orders/${id}/cancel`,
    close: (id: string | number) => `/api/v1/purchase/orders/${id}/close`,
    receive: (id: string | number) => `/api/v1/purchase/orders/${id}/receive`,
    rate: (id: string | number) => `/api/v1/purchase/orders/${id}/rate`,
    ordersItems: (id: string | number) => `/api/v1/purchase/orders/${id}/items`,
    ordersReceivings: (id: string | number) => `/api/v1/purchase/orders/${id}/receivings`,
    ordersRatings: (id: string | number) => `/api/v1/purchase/orders/${id}/ratings`,
    ordersExport: '/api/v1/purchase/orders/export',
    ordersImport: '/api/v1/purchase/orders/import',
    receivings: '/api/v1/purchase/receivings',
    purchaseReceivings: (id: string | number) => `/api/v1/purchase/receivings/${id}`,
    uploadPhoto: '/api/v1/purchase/receivings/upload-photo',
    dashboard: '/api/v1/purchase/dashboard',
    claimsTypeOptions: '/api/v1/purchase/claims/type-options',
    claimsStatusOptions: '/api/v1/purchase/claims/status-options',
    purchaseClaims: (id: string | number) => `/api/v1/purchase/claims/${id}`,
    claims: '/api/v1/purchase/claims',
    claimsConfirm: (id: string | number) => `/api/v1/purchase/claims/${id}/confirm`,
    pay: (id: string | number) => `/api/v1/purchase/claims/${id}/pay`,
    claimsClose: (id: string | number) => `/api/v1/purchase/claims/${id}/close`,
    rejectApplication: (id: string | number) => `/api/v1/purchase/claims/${id}/reject`,
    suppliersClaims: (id: string | number) => `/api/v1/purchase/suppliers/${id}/claims`,
    performanceDashboard: '/api/v1/purchase/performance/dashboard',
    performanceTopSuppliers: '/api/v1/purchase/performance/top-suppliers',
    performanceAlertSuppliers: '/api/v1/purchase/performance/alert-suppliers',
    performanceMonthlyTrend: '/api/v1/purchase/performance/monthly-trend',
    suppliersPerformance: (id: string | number) => `/api/v1/purchase/suppliers/${id}/performance`,
    performanceCalculate: (id: string | number) => `/api/v1/purchase/suppliers/${id}/performance/calculate`,
    updateLevel: (id: string | number) => `/api/v1/purchase/suppliers/${id}/performance/update-level`,
    batchUpdateLevels: '/api/v1/purchase/performance/batch-update-levels',

    // ========== 采购退货 ==========
    returnsTypeOptions: '/api/v1/purchase/returns/type-options',
    returnsStatusOptions: '/api/v1/purchase/returns/status-options',
    returns: '/api/v1/purchase/returns',
    returnsFromReceiving: '/api/v1/purchase/returns/from-receiving',
    purchaseReturns: (id: string | number) => `/api/v1/purchase/returns/${id}`,
    returnsSubmit: (id: string | number) => `/api/v1/purchase/returns/${id}/submit`,
    returnsApprove: (id: string | number) => `/api/v1/purchase/returns/${id}/approve`,
    returnsShip: (id: string | number) => `/api/v1/purchase/returns/${id}/ship`,
    returnsComplete: (id: string | number) => `/api/v1/purchase/returns/${id}/complete`,
    returnsCancel: (id: string | number) => `/api/v1/purchase/returns/${id}/cancel`,
  },

  // ==================== 委外管理模块 ====================
  outsource: {
    // 委外订单
    orders: '/api/v1/outsource/orders',
    outsourceOrders: (id: string | number) => `/api/v1/outsource/orders/${id}`,
    ordersSubmit: (id: string | number) => `/api/v1/outsource/orders/${id}/submit`,
    ordersApprove: (id: string | number) => `/api/v1/outsource/orders/${id}/approve`,
    ordersReject: (id: string | number) => `/api/v1/outsource/orders/${id}/reject`,
    ordersCancel: (id: string | number) => `/api/v1/outsource/orders/${id}/cancel`,
    ordersClose: (id: string | number) => `/api/v1/outsource/orders/${id}/close`,
    ordersSettle: (id: string | number) => `/api/v1/outsource/orders/${id}/settle`,
    ordersItems: (id: string | number) => `/api/v1/outsource/orders/${id}/items`,
    ordersShipments: (id: string | number) => `/api/v1/outsource/orders/${id}/shipments`,
    ordersReceivings: (id: string | number) => `/api/v1/outsource/orders/${id}/receivings`,
    // 委外发料
    shipments: '/api/v1/outsource/shipments',
    outsourceShipments: (id: string | number) => `/api/v1/outsource/shipments/${id}`,
    shipmentsScan: '/api/v1/outsource/shipments/scan',
    // 委外收货
    receivings: '/api/v1/outsource/receivings',
    outsourceReceivings: (id: string | number) => `/api/v1/outsource/receivings/${id}`,
    receivingsScan: '/api/v1/outsource/receivings/scan',
    receivingsQuality: (id: string | number) => `/api/v1/outsource/receivings/${id}/quality`,
    receivingsException: (id: string | number) => `/api/v1/outsource/receivings/${id}/exception`,
    receivingsWarehouse: (id: string | number) => `/api/v1/outsource/receivings/${id}/warehouse`,
    // 委外退料
    returns: '/api/v1/outsource/returns',
    outsourceReturns: (id: string | number) => `/api/v1/outsource/returns/${id}`,
    returnsWarehouse: (id: string | number) => `/api/v1/outsource/returns/${id}/warehouse`,
    // 委外看板
    dashboard: '/api/v1/outsource/dashboard',
  },

  // ========== Push ==========
  push: {
    device: '/api/v1/push/device',
    pushDevice: '/api/v1/push/device',
    list: '/api/v1/push/devices',
    // 兼容别名：factory.ts 引用
    registerDevice: '/api/v1/push/device',
    removeDevice: '/api/v1/push/device',
    listDevices: '/api/v1/push/devices',
  },

  // ========== NotificationSystemConfig（兼容别名，已合并到 notificationAdmin） ==========
  notificationSystemConfig: {
    get: '/api/v1/admin/notification-system-config',
    updateMasterSwitch: '/api/v1/admin/notification-system-config/master-switch',
    updateChannelSwitch: '/api/v1/admin/notification-system-config/channel-switch',
    updateRateLimit: '/api/v1/admin/notification-system-config/rate-limit',
    updateQuietHours: '/api/v1/admin/notification-system-config/quiet-hours',
    clearCache: '/api/v1/admin/notification-system-config/clear-cache',
  },

  // ========== NotificationSystemRule（兼容别名，已合并到 notificationAdmin） ==========
  notificationSystemRule: {
    list: '/api/v1/admin/notification-system-rules',
    module: (module: string | number) => `/api/v1/admin/notification-system-rules/module/${module}`,
    detail: (id: string | number) => `/api/v1/admin/notification-system-rules/${id}`,
    create: '/api/v1/admin/notification-system-rules',
    update: (id: string | number) => `/api/v1/admin/notification-system-rules/${id}`,
    delete: (id: string | number) => `/api/v1/admin/notification-system-rules/${id}`,
    batchStatus: '/api/v1/admin/notification-system-rules/batch-status',
    initModule: '/api/v1/admin/notification-system-rules/init-module',
  },

  // ========== Quality ==========
  quality: {
    list: '/api/v1/quality/inspection-items',
    inspectionItemsValueTypes: '/api/v1/quality/inspection-items/value-types',
    import: '/api/v1/quality/inspection-items/import',
    batchImport: '/api/v1/quality/inspection-items/batch-import',
    inspectionItemsImportTemplate: '/api/v1/quality/inspection-items/import-template',
    export: '/api/v1/quality/inspection-items/export',
    all: '/api/v1/quality/inspection-items/all',
    detail: (id: string | number) => `/api/v1/quality/inspection-items/${id}`,
    inspectionItems: '/api/v1/quality/inspection-items',
    qualityInspectionItems: (id: string | number) => `/api/v1/quality/inspection-items/${id}`,
    delete: (id: string | number) => `/api/v1/quality/inspection-items/${id}`,
    update: (id: string | number) => `/api/v1/quality/inspection-items/${id}/status`,
    templatesTypes: '/api/v1/quality/templates/types',
    templatesSamplingTypes: '/api/v1/quality/templates/sampling-types',
    templatesBatchImport: '/api/v1/quality/templates/batch-import',
    templatesImportTemplate: '/api/v1/quality/templates/import-template',
    templatesMatch: '/api/v1/quality/templates/match',
    qualityTemplates: (id: string | number) => `/api/v1/quality/templates/${id}`,
    templatesVersions: (id: string | number) => `/api/v1/quality/templates/${id}/versions`,
    templates: '/api/v1/quality/templates',
    copy: (id: string | number) => `/api/v1/quality/templates/${id}/copy`,
    newVersion: (id: string | number) => `/api/v1/quality/templates/${id}/new-version`,
    addItem: (id: string | number) => `/api/v1/quality/templates/${id}/items`,
    items: (id: string | number, itemId: string | number) => `/api/v1/quality/templates/${id}/items/${itemId}`,
    templatesItems: (template: string | number, item: string | number) => `/api/v1/quality/templates/${template}/items/${item}`,
    itemsSort: (template: string | number) => `/api/v1/quality/templates/${template}/items/sort`,
    templatesRelatedTasksStats: (id: string | number) => `/api/v1/quality/templates/${id}/related-tasks-stats`,
    syncTasks: (id: string | number) => `/api/v1/quality/templates/${id}/sync-tasks`,
    qualityTasks: (id: string | number) => `/api/v1/quality/tasks/${id}`,
    tasksPending: '/api/v1/quality/tasks/pending',
    inspectionTasksMy: '/api/v1/quality/tasks/my',
    statistics: '/api/v1/quality/tasks/statistics',
    tasks: '/api/v1/quality/tasks',
    start: (id: string | number) => `/api/v1/quality/tasks/${id}/start`,
    records: (id: string | number) => `/api/v1/quality/tasks/${id}/records`,
    tasksRecords: (taskId: string | number) => `/api/v1/quality/mobile/tasks/${taskId}/records`,
    complete: (id: string | number) => `/api/v1/quality/tasks/${id}/complete`,
    concession: (id: string | number) => `/api/v1/quality/tasks/${id}/concession`,
    cancel: (id: string | number) => `/api/v1/quality/tasks/${id}/cancel`,
    assign: (id: string | number) => `/api/v1/quality/tasks/${id}/assign`,
    addSamples: (id: string | number) => `/api/v1/quality/tasks/${id}/add-samples`,
    resetToPending: (id: string | number) => `/api/v1/quality/tasks/${id}/reset-to-pending`,
    refreshRecords: (id: string | number) => `/api/v1/quality/tasks/${id}/refresh-records`,
    aqlStandardsLevels: '/api/v1/quality/aql-standards/levels',
    aqlStandardsAqlValues: '/api/v1/quality/aql-standards/aql-values',
    aqlStandardsCalculateSample: '/api/v1/quality/aql-standards/calculate-sample',
    judgeLot: '/api/v1/quality/aql-standards/judge-lot',
    qualityAqlStandards: (id: string | number) => `/api/v1/quality/aql-standards/${id}`,
    aqlStandardsAll: '/api/v1/quality/aql-standards/all',
    aqlStandardsLevel: (level: string | number) => `/api/v1/quality/aql-standards/level/${level}`,
    aqlStandards: '/api/v1/quality/aql-standards',
    aqlStandardsStatus: (id: string | number) => `/api/v1/quality/aql-standards/${id}/status`,
    aqlStandardsImport: '/api/v1/quality/aql-standards/import',
    selfInspectionConfigsFrequencyTypes: '/api/v1/quality/self-inspection-configs/frequency-types',
    selfInspectionConfigsTimeUnits: '/api/v1/quality/self-inspection-configs/time-units',
    selfInspectionConfigsReminders: '/api/v1/quality/self-inspection-configs/reminders',
    overdue: '/api/v1/quality/self-inspection-configs/overdue',
    triggerOverdue: '/api/v1/quality/self-inspection-configs/trigger-overdue',
    selfInspectionConfigsFind: '/api/v1/quality/self-inspection-configs/find',
    stats: (workstationId: string | number) => `/api/v1/quality/self-inspection-configs/workstation/${workstationId}/stats`,
    qualitySelfInspectionConfigs: (id: string | number) => `/api/v1/quality/self-inspection-configs/${id}`,
    selfInspectionConfigsAll: '/api/v1/quality/self-inspection-configs/all',
    selfInspectionConfigs: '/api/v1/quality/self-inspection-configs',
    selfInspectionConfigsStatus: (id: string | number) => `/api/v1/quality/self-inspection-configs/${id}/status`,
    trigger: (id: string | number) => `/api/v1/quality/self-inspection-configs/${id}/trigger`,
    ncrOrdersSourceTypes: '/api/v1/quality/ncr-orders/source-types',
    ncrOrdersDefectLevels: '/api/v1/quality/ncr-orders/defect-levels',
    ncrOrdersDispositions: '/api/v1/quality/ncr-orders/dispositions',
    ncrOrdersStatuses: '/api/v1/quality/ncr-orders/statuses',
    qualityNcrOrders: (id: string | number) => `/api/v1/quality/ncr-orders/${id}`,
    ncrOrdersPending: '/api/v1/quality/ncr-orders/pending',
    ncrOrdersStatistics: '/api/v1/quality/ncr-orders/statistics',
    trend: '/api/v1/quality/ncr-orders/trend',
    ncrOrdersProcessingTime: '/api/v1/quality/ncr-orders/processing-time',
    ncrOrdersSupplierRanking: '/api/v1/quality/ncr-orders/supplier-ranking',
    ncrOrdersMaterialRanking: '/api/v1/quality/ncr-orders/material-ranking',
    ncrOrders: '/api/v1/quality/ncr-orders',
    submitForReview: (id: string | number) => `/api/v1/quality/ncr-orders/${id}/submit-for-review`,
    ncrOrdersConfirm: (id: string | number) => `/api/v1/quality/ncr-orders/${id}/confirm`,
    ncrOrdersWithdraw: (id: string | number) => `/api/v1/quality/ncr-orders/${id}/withdraw`,
    ncrOrdersIsolate: (id: string | number) => `/api/v1/quality/ncr-orders/${id}/isolate`,
    ncrOrdersLoss: (id: string | number) => `/api/v1/quality/ncr-orders/${id}/loss`,
    ncrOrdersAssign: (id: string | number) => `/api/v1/quality/ncr-orders/${id}/assign`,
    disposition: (id: string | number) => `/api/v1/quality/ncr-orders/${id}/disposition`,
    approveApplication: (id: string | number) => `/api/v1/quality/ncr-orders/${id}/approve`,
    execute: (id: string | number) => `/api/v1/quality/ncr-orders/${id}/execute`,
    close: (id: string | number) => `/api/v1/quality/ncr-orders/${id}/close`,
    ncrOrdersCancel: (id: string | number) => `/api/v1/quality/ncr-orders/${id}/cancel`,
    ncrOrdersLogs: (id: string | number) => `/api/v1/quality/ncr-orders/${id}/logs`,
    remarks: (id: string | number) => `/api/v1/quality/ncr-orders/${id}/remarks`,
    escalateQrqc: (id: string | number) => `/api/v1/quality/ncr-orders/${id}/escalate-qrqc`,
    ncrOrdersQrqc: (id: string | number) => `/api/v1/quality/ncr-orders/${id}/qrqc`,
    verifyQrqc: (id: string | number) => `/api/v1/quality/ncr-orders/${id}/verify-qrqc`,
    // 不良原因库
    defectReasons: '/api/v1/quality/defect-reasons',
    defectReasonsBatch: '/api/v1/quality/defect-reasons/batch',
    defectReasonsOptions: '/api/v1/quality/defect-reasons/options',
    defectReasonsItem: (id: string | number) => `/api/v1/quality/defect-reasons/${id}`,
    mobileDefectReasons: '/api/v1/quality/mobile/defect-reasons',
    iqcPendingReceivings: '/api/v1/quality/iqc/pending-receivings',
    createTask: (receivingId: string | number) => `/api/v1/quality/iqc/receivings/${receivingId}/create-task`,
    batchCreateTasks: '/api/v1/quality/iqc/batch-create-tasks',
    iqcTasks: '/api/v1/quality/iqc/tasks',
    iqcStatistics: '/api/v1/quality/iqc/statistics',
    iqcControlMode: '/api/v1/quality/iqc/control-mode',
    controlMode: '/api/v1/quality/iqc/control-mode',
    iqcMaterials: (materialId: string | number) => `/api/v1/quality/iqc/materials/${materialId}`,
    materials: '/api/v1/quality/iqc/materials',
    batch: '/api/v1/quality/iqc/materials/batch',
    materialsBatch: '/api/v1/quality/iqc/materials/batch',
    materialsSkipCheck: (materialId: string | number) => `/api/v1/quality/iqc/materials/${materialId}/skip-check`,
    materialsSkipIqc: (materialId: string | number) => `/api/v1/quality/iqc/materials/${materialId}/skip-iqc`,
    materialsNeedIqc: (materialId: string | number) => `/api/v1/quality/iqc/materials/${materialId}/need-iqc`,
    batchSkip: '/api/v1/quality/iqc/materials/batch-skip',
    batchNeed: '/api/v1/quality/iqc/materials/batch-need',
    quickInspection: '/api/v1/quality/quick-inspection',
    templatesSuggestions: '/api/v1/quality/quick-inspection/templates/suggestions',
    quickInspectionTypes: '/api/v1/quality/quick-inspection/types',
    mobilePendingTasks: '/api/v1/quality/mobile/pending-tasks',
    mobileTodayStatistics: '/api/v1/quality/mobile/today-statistics',
    mobileScan: '/api/v1/quality/mobile/scan',
    mobileTasks: (id: string | number) => `/api/v1/quality/mobile/tasks/${id}`,
    tasksStart: (task: string | number) => `/api/v1/quality/lpa/tasks/${task}/start`,
    tasksComplete: (task: string | number) => `/api/v1/quality/lpa/tasks/${task}/complete`,
    selfInspectionPending: '/api/v1/quality/mobile/self-inspection/pending',
    selfInspectionRecords: '/api/v1/quality/mobile/self-inspection/records',
    rate: '/api/v1/quality/mobile/self-inspection/rate',
    selfInspectionTrigger: '/api/v1/quality/mobile/self-inspection/trigger',
    dashboardOverview: '/api/v1/quality/dashboard/overview',
    dashboardKpi: '/api/v1/quality/dashboard/kpi',
    dashboardTaskTypeDistribution: '/api/v1/quality/dashboard/task-type-distribution',
    dashboardPassRateTrend: '/api/v1/quality/dashboard/pass-rate-trend',
    dashboardDefectDistribution: '/api/v1/quality/dashboard/defect-distribution',
    dashboardWorkstationStatus: '/api/v1/quality/dashboard/workstation-status',
    dashboardInspectorPerformance: '/api/v1/quality/dashboard/inspector-performance',
    dashboardAlerts: '/api/v1/quality/dashboard/alerts',
    inspectionSummaryDateRangeOptions: '/api/v1/quality/inspection-summary/date-range-options',
    inspectionSummaryMetricExplanations: '/api/v1/quality/inspection-summary/metric-explanations',
    summary: '/api/v1/quality/inspection-summary/summary',
    inspectionSummaryByTaskType: '/api/v1/quality/inspection-summary/by-task-type',
    inspectionSummaryByProduct: '/api/v1/quality/inspection-summary/by-product',
    inspectionSummaryByMaterial: '/api/v1/quality/inspection-summary/by-material',
    inspectionSummaryBySupplier: '/api/v1/quality/inspection-summary/by-supplier',
    inspectionSummaryByInspector: '/api/v1/quality/inspection-summary/by-inspector',
    inspectionSummaryByWorkstation: '/api/v1/quality/inspection-summary/by-workstation',
    inspectionSummaryByWorkshop: '/api/v1/quality/inspection-summary/by-workshop',
    inspectionSummaryDefectTop: '/api/v1/quality/inspection-summary/defect-top',
    inspectionSummaryTrend: '/api/v1/quality/inspection-summary/trend',
    inspectionSummaryProductDetail: (productId: string | number) => `/api/v1/quality/inspection-summary/product-detail/${productId}`,
    inspectionSummarySupplierDetail: (supplierId: string | number) => `/api/v1/quality/inspection-summary/supplier-detail/${supplierId}`,
    inspectionSummaryNcrSummary: '/api/v1/quality/inspection-summary/ncr-summary',
    refreshCache: '/api/v1/quality/inspection-summary/refresh-cache',
    enumsSourceTypes: '/api/v1/quality/8d-reports/enums/source-types',
    enumsStatuses: '/api/v1/quality/8d-reports/enums/statuses',
    enumsSteps: '/api/v1/quality/8d-reports/enums/steps',
    enumsPriorities: '/api/v1/quality/8d-reports/enums/priorities',
    enumsSeverities: '/api/v1/quality/8d-reports/enums/severities',
    enumsTeamRoles: '/api/v1/quality/8d-reports/enums/team-roles',
    '8dReportsStatistics': '/api/v1/quality/8d-reports/statistics',
    '8dReportsSlaConfigs': '/api/v1/quality/8d-reports/sla-configs',
    slaConfigs: '/api/v1/quality/8d-reports/sla-configs',
    slaConfigsRefreshCache: '/api/v1/quality/8d-reports/sla-configs/refresh-cache',
    quality8dReports: (id: string | number) => `/api/v1/quality/8d-reports/${id}`,
    '8dReports': '/api/v1/quality/8d-reports',
    fromQrqc: (ncrId: string | number) => `/api/v1/quality/8d-reports/from-qrqc/${ncrId}`,
    stepD0: (id: string | number) => `/api/v1/quality/8d-reports/${id}/step/d0`,
    stepD1: (id: string | number) => `/api/v1/quality/8d-reports/${id}/step/d1`,
    stepD2: (id: string | number) => `/api/v1/quality/8d-reports/${id}/step/d2`,
    stepD3: (id: string | number) => `/api/v1/quality/8d-reports/${id}/step/d3`,
    stepD4: (id: string | number) => `/api/v1/quality/8d-reports/${id}/step/d4`,
    stepD5: (id: string | number) => `/api/v1/quality/8d-reports/${id}/step/d5`,
    stepD6: (id: string | number) => `/api/v1/quality/8d-reports/${id}/step/d6`,
    stepD7: (id: string | number) => `/api/v1/quality/8d-reports/${id}/step/d7`,
    stepD8: (id: string | number) => `/api/v1/quality/8d-reports/${id}/step/d8`,
    stepBackward: (id: string | number) => `/api/v1/quality/8d-reports/${id}/step-backward`,
    teamMembers: (id: string | number) => `/api/v1/quality/8d-reports/${id}/team-members`,
    teamMembersBatch: (id: string | number) => `/api/v1/quality/8d-reports/${id}/team-members/batch`,
    '8dReportsTeamMembers': (id: string | number, userId: string | number) => `/api/v1/quality/8d-reports/${id}/team-members/${userId}`,
    confirm: (id: string | number) => `/api/v1/quality/8d-reports/${id}/confirm`,
    ncrLinks: (id: string | number) => `/api/v1/quality/8d-reports/${id}/ncr-links`,
    '8dReportsNcrLinks': (id: string | number, ncrId: string | number) => `/api/v1/quality/8d-reports/${id}/ncr-links/${ncrId}`,
    '8dReportsClose': (id: string | number) => `/api/v1/quality/8d-reports/${id}/close`,
    '8dReportsCancel': (id: string | number) => `/api/v1/quality/8d-reports/${id}/cancel`,
    '8dReportsLogs': (id: string | number) => `/api/v1/quality/8d-reports/${id}/logs`,
    '8dReportsLpaStatus': (id: string | number) => `/api/v1/quality/8d-reports/${id}/lpa-status`,
    triggerLpa: (id: string | number) => `/api/v1/quality/8d-reports/${id}/trigger-lpa`,
    '8dReportsLpaItems': (id: string | number) => `/api/v1/quality/8d-reports/${id}/lpa-items`,
    lpaLayerConfigs: (layer: string | number) => `/api/v1/quality/lpa/layer-configs/${layer}`,
    active: '/api/v1/quality/lpa/layer-configs/active',
    layerConfigsFrequencyTypes: '/api/v1/quality/lpa/layer-configs/frequency-types',
    layerConfigs: '/api/v1/quality/lpa/layer-configs',
    templatesAreaTypes: '/api/v1/quality/lpa/templates/area-types',
    templatesAuditTypes: '/api/v1/quality/lpa/templates/audit-types',
    lpaTemplates: (template: string | number) => `/api/v1/quality/lpa/templates/${template}`,
    templatesCopy: (template: string | number) => `/api/v1/quality/lpa/templates/${template}/copy`,
    templatesToggleStatus: (template: string | number) => `/api/v1/quality/lpa/templates/${template}/toggle-status`,
    lpaTemplateItems: (template: string | number) => `/api/v1/quality/lpa/templates/${template}/items`,
    lpaTemplateItem: (template: string | number, item: string | number) => `/api/v1/quality/lpa/templates/${template}/items/${item}`,
    itemsBatch: (template: string | number) => `/api/v1/quality/lpa/templates/${template}/items/batch`,
    lpaTemplateItemsSort: (template: string | number) => `/api/v1/quality/lpa/templates/${template}/items/sort`,
    lpaTemplateItemsFromLibrary: (template: string | number) => `/api/v1/quality/lpa/templates/${template}/items/from-library`,
    lpaTemplateCreateVersion: (template: string | number) => `/api/v1/quality/lpa/templates/${template}/create-version`,
    lpaTemplateVersions: (template: string | number) => `/api/v1/quality/lpa/templates/${template}/versions`,
    lpaLibraryItems: '/api/v1/quality/lpa/library-items',
    lpaLibraryItem: (item: string | number) => `/api/v1/quality/lpa/library-items/${item}`,
    lpaLibraryItemsFromTemplate: '/api/v1/quality/lpa/library-items/from-template',
    lpaSchedules: (schedule: string | number) => `/api/v1/quality/lpa/schedules/${schedule}`,
    schedules: '/api/v1/quality/lpa/schedules',
    schedulesToggle: (schedule: string | number) => `/api/v1/quality/lpa/schedules/${schedule}/toggle`,
    generateTasks: (schedule: string | number) => `/api/v1/quality/lpa/schedules/${schedule}/generate-tasks`,
    schedulesTasks: (schedule: string | number) => `/api/v1/quality/lpa/schedules/${schedule}/tasks`,
    schedulesMonthlySheet: (schedule: string | number) => `/api/v1/quality/lpa/schedules/${schedule}/monthly-sheet`,
    lpaConfig: '/api/v1/quality/lpa/config',
    lpaConfigUpdate: '/api/v1/quality/lpa/config',
    tasksStatuses: '/api/v1/quality/lpa/tasks/statuses',
    tasksSourceTypes: '/api/v1/quality/lpa/tasks/source-types',
    tasksExport: '/api/v1/quality/lpa/tasks/export',
    lpaTasks: (task: string | number) => `/api/v1/quality/lpa/tasks/${task}`,
    lpaTasksMy: '/api/v1/quality/lpa/tasks/my',
    tasksToday: '/api/v1/quality/lpa/tasks/today',
    tasksPendingReview: '/api/v1/quality/lpa/tasks/pending-review',
    tasksReview: (task: string | number) => `/api/v1/quality/lpa/tasks/${task}/review`,
    lpaRosters: '/api/v1/quality/lpa/rosters',
    lpaRostersPrefill: '/api/v1/quality/lpa/rosters/prefill',
    lpaRostersBatch: '/api/v1/quality/lpa/rosters/batch',
    lpaRoster: (roster: string | number) => `/api/v1/quality/lpa/rosters/${roster}`,
    tasksAssign: (task: string | number) => `/api/v1/quality/lpa/tasks/${task}/assign`,
    tasksCancel: (task: string | number) => `/api/v1/quality/lpa/tasks/${task}/cancel`,
    tasksItems: (task: string | number) => `/api/v1/quality/lpa/tasks/${task}/items`,
    results: (task: string | number) => `/api/v1/quality/lpa/tasks/${task}/results`,
    resultsBatch: (task: string | number) => `/api/v1/quality/lpa/tasks/${task}/results/batch`,
    findingsSeverities: '/api/v1/quality/lpa/findings/severities',
    findingsStatuses: '/api/v1/quality/lpa/findings/statuses',
    findingsExport: '/api/v1/quality/lpa/findings/export',
    lpaFindings: (finding: string | number) => `/api/v1/quality/lpa/findings/${finding}`,
    findingsMy: '/api/v1/quality/lpa/findings/my',
    findings: (finding: string | number) => `/api/v1/quality/lpa/findings/${finding}`,
    findingsAssign: (finding: string | number) => `/api/v1/quality/lpa/findings/${finding}/assign`,
    findingsClose: (finding: string | number) => `/api/v1/quality/lpa/findings/${finding}/close`,
    findingsCreateNcr: (finding: string | number) => `/api/v1/quality/lpa/findings/${finding}/create-ncr`,
    verify: (finding: string | number) => `/api/v1/quality/lpa/findings/${finding}/verify`,
    findingsCancel: (finding: string | number) => `/api/v1/quality/lpa/findings/${finding}/cancel`,
    statisticsOverview: '/api/v1/quality/lpa/statistics/overview',
    statisticsCompletion: '/api/v1/quality/lpa/statistics/completion',
    statisticsFindings: '/api/v1/quality/lpa/statistics/findings',
    statisticsTrend: '/api/v1/quality/lpa/statistics/trend',
    statisticsLayerComparison: '/api/v1/quality/lpa/statistics/layer-comparison',
    statisticsEightDTasks: '/api/v1/quality/lpa/statistics/eight-d-tasks',
    lpaEightDConfigs: '/api/v1/quality/lpa/eight-d-configs',
    eightDConfigs: (severity: string | number) => `/api/v1/quality/lpa/eight-d-configs/${severity}`,
    eightDConfigsBlockingModes: '/api/v1/quality/lpa/eight-d-configs/blocking-modes',

    // ========== CAPA 纠正预防措施 ==========
    capaList: '/api/v1/quality/capas',
    capaMy: '/api/v1/quality/capas/my',
    capaStatistics: '/api/v1/quality/capas/statistics',
    capaStatuses: '/api/v1/quality/capas/statuses',
    capaSourceTypes: '/api/v1/quality/capas/source-types',
    capaActionStatuses: '/api/v1/quality/capas/action-statuses',
    capaDetail: (id: string | number) => `/api/v1/quality/capas/${id}`,
    capaDelete: (id: string | number) => `/api/v1/quality/capas/${id}`,
    capaUpdate: (id: string | number) => `/api/v1/quality/capas/${id}`,
    capaSubmit: (id: string | number) => `/api/v1/quality/capas/${id}/submit`,
    capaSubmitVerification: (id: string | number) => `/api/v1/quality/capas/${id}/submit-verification`,
    capaVerify: (id: string | number) => `/api/v1/quality/capas/${id}/verify`,
    capaCancel: (id: string | number) => `/api/v1/quality/capas/${id}/cancel`,
    capaLogs: (id: string | number) => `/api/v1/quality/capas/${id}/logs`,

    // ==================== QRQC 快速反应 ====================
    qrqcCases: '/api/v1/quality/qrqc-cases',
    qrqcStatistics: '/api/v1/quality/qrqc-cases/statistics',
    qrqcBoard: '/api/v1/quality/qrqc-cases/board',
    qrqcCaseDetail: (id: string | number) => `/api/v1/quality/qrqc-cases/${id}`,
    qrqcCaseContainment: (id: string | number) => `/api/v1/quality/qrqc-cases/${id}/containment`,
    qrqcCaseAnalysis: (id: string | number) => `/api/v1/quality/qrqc-cases/${id}/analysis`,
    qrqcCaseAnalysisSubmit: (id: string | number) => `/api/v1/quality/qrqc-cases/${id}/analysis-submit`,
    qrqcCaseActionComplete: (id: string | number, type: string) => `/api/v1/quality/qrqc-cases/${id}/actions/${type}/complete`,
    qrqcCaseDeliverable: (id: string | number, itemKey: string) => `/api/v1/quality/qrqc-cases/${id}/deliverables/${itemKey}`,
    qrqcCaseVerify: (id: string | number) => `/api/v1/quality/qrqc-cases/${id}/verify`,
    qrqcCaseReject: (id: string | number) => `/api/v1/quality/qrqc-cases/${id}/reject`,
    qrqcCaseClose: (id: string | number) => `/api/v1/quality/qrqc-cases/${id}/close`,
    qrqcCaseLpaItems: (id: string | number) => `/api/v1/quality/qrqc-cases/${id}/lpa-items`,
    qrqcCaseLpaItemPause: (id: string | number, itemId: string | number) => `/api/v1/quality/qrqc-cases/${id}/lpa-items/${itemId}/pause`,
    qrqcCaseEscalate8d: (id: string | number) => `/api/v1/quality/qrqc-cases/${id}/escalate-8d`,
    qrqcMeetings: '/api/v1/quality/qrqc-meetings',
    qrqcReviewQueue: '/api/v1/quality/qrqc-meetings/review-queue',
    qrqcMeetingDetail: (id: string | number) => `/api/v1/quality/qrqc-meetings/${id}`,
    qrqcMeetingItems: (id: string | number) => `/api/v1/quality/qrqc-meetings/${id}/items`,
    capaActions: (id: string | number) => `/api/v1/quality/capas/${id}/actions`,
    capaAction: (id: string | number, actionId: string | number) => `/api/v1/quality/capas/${id}/actions/${actionId}`,
  },

  // ========== Role ==========
  role: {
    list: '/api/v1/roles',
    create: '/api/v1/roles',
    detail: (role: string | number) => `/api/v1/roles/${role}`,
    roles: (role: string | number) => `/api/v1/roles/${role}`,
    delete: (role: string | number) => `/api/v1/roles/${role}`,
    permissions: (role: string | number) => `/api/v1/roles/${role}/permissions`,
    rolesPermissions: (role: string | number) => `/api/v1/roles/${role}/permissions`,
  },

  // ========== RoleWizard ==========
  roleWizard: {
    list: '/api/v1/role-wizard/templates',
    roleWizardConfig: '/api/v1/role-wizard/config',
    clear: '/api/v1/role-wizard/cache/clear',
  },

  // ========== Sale ==========
  sale: {
    list: '/api/v1/sales/shipments',
    statistics: '/api/v1/sales/shipments/statistics',
    detail: (id: string | number) => `/api/v1/sales/shipments/${id}`,
    shipmentsAvailableBatches: (materialId: string | number) => `/api/v1/sales/shipments/available-batches/${materialId}`,
    shipments: '/api/v1/sales/shipments',
    confirm: (id: string | number) => `/api/v1/sales/shipments/${id}/confirm`,
    update: (id: string | number) => `/api/v1/sales/shipments/${id}/received`,
    cancel: (id: string | number) => `/api/v1/sales/shipments/${id}/cancel`,
  },

  // ========== Shipments (发货管理) ==========
  shipments: {
    list: '/api/v1/sales/shipments',
    shipments: '/api/v1/sales/shipments',
    statistics: '/api/v1/sales/shipments/statistics',
    shippableItems: (salesOrderId: string | number) => `/api/v1/sales/shipments/shippable-items/${salesOrderId}`,
    availableBatches: (materialId: string | number) => `/api/v1/sales/shipments/available-batches/${materialId}`,
    detail: (id: string | number) => `/api/v1/sales/shipments/${id}`,
    confirm: (id: string | number) => `/api/v1/sales/shipments/${id}/confirm`,
    received: (id: string | number) => `/api/v1/sales/shipments/${id}/received`,
    cancel: (id: string | number) => `/api/v1/sales/shipments/${id}/cancel`,
  },

  // ========== SalesCustomers ==========
  salesCustomers: {
    list: '/api/v1/sales/customers',
    statistics: '/api/v1/sales/customers/statistics',
    customersSalesRanking: '/api/v1/sales/customers/sales-ranking',
    active: '/api/v1/sales/customers/active',
    blacklisted: '/api/v1/sales/customers/blacklisted',
    customers: '/api/v1/sales/customers',
    batchDelete: '/api/v1/sales/customers/batch-delete',
    findByCode: (code: string | number) => `/api/v1/sales/customers/code/${code}`,
    detail: (id: string | number) => `/api/v1/sales/customers/${id}`,
    customersStatistics: (id: string | number) => `/api/v1/sales/customers/${id}/statistics`,
    customersSalesTrend: (id: string | number) => `/api/v1/sales/customers/${id}/sales-trend`,
    salesCustomers: (id: string | number) => `/api/v1/sales/customers/${id}`,
    update: (id: string | number) => `/api/v1/sales/customers/${id}/status`,
    customersCreditLevel: (id: string | number) => `/api/v1/sales/customers/${id}/credit-level`,
    delete: (id: string | number) => `/api/v1/sales/customers/${id}`,
    customersMaterialSuppliers: (customerId: string | number) => `/api/v1/sales/customers/${customerId}/material-suppliers`,
    materialSuppliers: (customerId: string | number) => `/api/v1/sales/customers/${customerId}/material-suppliers`,
  },

  // ========== SalesOrderNumber ==========
  salesOrderNumber: {
    generate: '/api/v1/sales/order-number/generate',
    validate: '/api/v1/sales/order-number/validate',
    parse: '/api/v1/sales/order-number/parse',
    list: '/api/v1/sales/order-number/config',
    config: '/api/v1/sales/order-number/config',
  },

  // ========== SalesOrders ==========
  salesOrders: {
    list: '/api/v1/sales/orders',
    statistics: '/api/v1/sales/orders/statistics',
    orders: '/api/v1/sales/orders',
    detail: (id: string | number) => `/api/v1/sales/orders/${id}`,
    ordersStatistics: (id: string | number) => `/api/v1/sales/orders/${id}/statistics`,
    salesOrders: (id: string | number) => `/api/v1/sales/orders/${id}`,
    delete: (id: string | number) => `/api/v1/sales/orders/${id}`,
    approveApplication: (id: string | number) => `/api/v1/sales/orders/${id}/approve`,
    cancel: (id: string | number) => `/api/v1/sales/orders/${id}/cancel`,
  },

  // ========== StorageManagement ==========
  storageManagement: {
    list: '/api/v1/storage-management/status',
    detail: (driver: string | number) => `/api/v1/storage-management/drivers/${driver}`,
    statistics: (driver: string | number) => `/api/v1/storage-management/drivers/${driver}/statistics`,
    test: (driver: string | number) => `/api/v1/storage-management/drivers/${driver}/test`,
    storageManagementFiles: '/api/v1/storage-management/files',
    preview: '/api/v1/storage-management/migration/preview',
    execute: '/api/v1/storage-management/migration/execute',
    cleanupPreview: '/api/v1/storage-management/cleanup/preview',
    cleanupExecute: '/api/v1/storage-management/cleanup/execute',
  },

  // ========== SystemConfigs ==========
  systemConfigs: {
    list: '/api/v1/system/configs',
    configs: '/api/v1/system/configs',
    detail: (key: string | number) => `/api/v1/system/configs/${key}`,
    systemConfigs: (key: string | number) => `/api/v1/system/configs/${key}`,
    delete: (key: string | number) => `/api/v1/system/configs/${key}`,
    groupsList: '/api/v1/system/configs/groups/list',
    configsGroups: (group: string | number) => `/api/v1/system/configs/groups/${group}`,
    typesList: '/api/v1/system/configs/types/list',
    update: '/api/v1/system/configs/batch/update',
    refresh: '/api/v1/system/configs/cache/refresh',
    preload: '/api/v1/system/configs/cache/preload',
    statsInfo: '/api/v1/system/configs/stats/info',
  },

  // ========== SystemMenu ==========
  systemMenu: {
    userMenus: '/api/v1/system/menu/user-menus',
    list: '/api/v1/system/menu',
    menuList: '/api/v1/system/menu/list',
    nameExists: '/api/v1/system/menu/name-exists',
    pathExists: '/api/v1/system/menu/path-exists',
    sort: '/api/v1/system/menu/sort',
    menu: '/api/v1/system/menu',
    detail: (id: string | number) => `/api/v1/system/menu/${id}`,
    systemMenu: (id: string | number) => `/api/v1/system/menu/${id}`,
    delete: (id: string | number) => `/api/v1/system/menu/${id}`,
  },

  // ========== Tooling ==========
  tooling: {
    dashboard: '/api/v1/tooling/dashboard',
    // 领用与归还（2026-09 领用化：无审批环节）
    applications: '/api/v1/tooling/applications',
    createApplication: '/api/v1/tooling/applications',
    detail: (id: string | number) => `/api/v1/tooling/applications/${id}`,
    returnApplication: (id: string | number) => `/api/v1/tooling/applications/${id}/return`,
    cancel: (id: string | number) => `/api/v1/tooling/applications/${id}/cancel`,
    alerts: '/api/v1/tooling/alerts',
    unreadAlerts: '/api/v1/tooling/alerts/unread',
    checkAlerts: '/api/v1/tooling/alerts/check',
    handleAlert: (id: string | number) => `/api/v1/tooling/alerts/${id}/handle`,
    ignoreAlert: (id: string | number) => `/api/v1/tooling/alerts/${id}/ignore`,
    toolList: '/api/v1/tooling/tools',
    toolCreate: '/api/v1/tooling/tools',
    import: '/api/v1/tooling/tools/import',
    toolDetail: (id: string | number) => `/api/v1/tooling/tools/${id}`,
    toolUpdate: (id: string | number) => `/api/v1/tooling/tools/${id}`,
    toolDelete: (id: string | number) => `/api/v1/tooling/tools/${id}`,
    toolReplace: (id: string | number) => `/api/v1/tooling/tools/${id}/replace`,
    gaugeList: '/api/v1/tooling/gauges',
    gaugeCreate: '/api/v1/tooling/gauges',
    gaugesImport: '/api/v1/tooling/gauges/import',
    gaugeDetail: (id: string | number) => `/api/v1/tooling/gauges/${id}`,
    gaugeUpdate: (id: string | number) => `/api/v1/tooling/gauges/${id}`,
    gaugeDelete: (id: string | number) => `/api/v1/tooling/gauges/${id}`,
    gaugeBorrow: (id: string | number) => `/api/v1/tooling/gauges/${id}/borrow`,
    gaugeReturn: (id: string | number) => `/api/v1/tooling/gauges/${id}/return`,
    gaugeMount: (id: string | number) => `/api/v1/tooling/gauges/${id}/mount`,
    gaugeUnmount: (id: string | number) => `/api/v1/tooling/gauges/${id}/unmount`,
    gaugeCalibrations: (id: string | number) => `/api/v1/tooling/gauges/${id}/calibrations`,
    gaugeInspectionRecords: (id: string | number) => `/api/v1/tooling/gauges/${id}/inspection-records`,
    // 检具蓝牙绑定（一检具一配对；换绑/解绑为特殊权限）
    gaugeBluetoothBindingList: '/api/v1/tooling/gauge-bluetooth-bindings',
    gaugeBluetoothBindingCreate: '/api/v1/tooling/gauge-bluetooth-bindings',
    gaugeBluetoothBindingDetail: (id: string | number) => `/api/v1/tooling/gauge-bluetooth-bindings/${id}`,
    gaugeBluetoothBindingRebind: (id: string | number) => `/api/v1/tooling/gauge-bluetooth-bindings/${id}/rebind`,
    gaugeBluetoothBindingUnbind: (id: string | number) => `/api/v1/tooling/gauge-bluetooth-bindings/${id}/unbind`,
    // 日志挂检具维度（解绑会删除绑定行，按绑定ID查不到历史）
    gaugeBluetoothBindingLogs: (gaugeId: string | number) => `/api/v1/tooling/gauges/${gaugeId}/bluetooth-logs`,
    // 检具特征档案（识别能力的型号库：新增型号 = 加一条档案数据）
    gaugeFingerprintProfileList: '/api/v1/tooling/gauge-fingerprint-profiles',
    gaugeFingerprintProfileCreate: '/api/v1/tooling/gauge-fingerprint-profiles',
    gaugeFingerprintProfileDetail: (id: string | number) => `/api/v1/tooling/gauge-fingerprint-profiles/${id}`,
    gaugeFingerprintProfileUpdate: (id: string | number) => `/api/v1/tooling/gauge-fingerprint-profiles/${id}`,
    gaugeFingerprintProfileDelete: (id: string | number) => `/api/v1/tooling/gauge-fingerprint-profiles/${id}`,
    // 指纹采集样本（新检具检测一次特征后固化成档案）
    gaugeFingerprintSampleList: '/api/v1/tooling/gauge-fingerprint-samples',
    gaugeFingerprintSampleCapture: '/api/v1/tooling/gauge-fingerprint-samples',
    gaugeFingerprintSampleDetail: (id: string | number) => `/api/v1/tooling/gauge-fingerprint-samples/${id}`,
    gaugeFingerprintSamplePromote: (id: string | number) => `/api/v1/tooling/gauge-fingerprint-samples/${id}/promote`,
    gaugeFingerprintSampleIgnore: (id: string | number) => `/api/v1/tooling/gauge-fingerprint-samples/${id}/ignore`,
    gaugeFingerprintSampleDelete: (id: string | number) => `/api/v1/tooling/gauge-fingerprint-samples/${id}`,
    fixtureList: '/api/v1/tooling/fixtures',
    fixtureCreate: '/api/v1/tooling/fixtures',
    fixturesImport: '/api/v1/tooling/fixtures/import',
    fixtureDetail: (id: string | number) => `/api/v1/tooling/fixtures/${id}`,
    fixtureUpdate: (id: string | number) => `/api/v1/tooling/fixtures/${id}`,
    fixtureDelete: (id: string | number) => `/api/v1/tooling/fixtures/${id}`,
    fixtureUse: (id: string | number) => `/api/v1/tooling/fixtures/${id}/use`,
    fixtureReturn: (id: string | number) => `/api/v1/tooling/fixtures/${id}/return`,
    fixturesUsageLogs: (id: string | number) => `/api/v1/tooling/fixtures/${id}/usage-logs`,
    fixtureMaintain: (id: string | number) => `/api/v1/tooling/fixtures/${id}/maintain`,
    fixturesMaintenanceLogs: (id: string | number) => `/api/v1/tooling/fixtures/${id}/maintenance-logs`,
    moldList: '/api/v1/tooling/molds',
    moldCreate: '/api/v1/tooling/molds',
    moldsImport: '/api/v1/tooling/molds/import',
    moldDetail: (id: string | number) => `/api/v1/tooling/molds/${id}`,
    moldUpdate: (id: string | number) => `/api/v1/tooling/molds/${id}`,
    moldDelete: (id: string | number) => `/api/v1/tooling/molds/${id}`,
    // ===== factory.ts 兼容别名 =====
    cancelApplication: (id: string | number) => `/api/v1/tooling/applications/${id}/cancel`,
  },

  // ========== Trace ==========
  trace: {
    list: '/api/v1/trace/query',
    query: '/api/v1/trace/query',
    forward: (materialBatchNo: string) => `/api/v1/trace/material/${encodeURIComponent(materialBatchNo)}`,
    backward: (batchNo: string) => `/api/v1/trace/batch/${encodeURIComponent(batchNo)}`,
    full: (batchNo: string) => `/api/v1/trace/full/${encodeURIComponent(batchNo)}`,
    lifecycle: (batchNo: string) => `/api/v1/trace/lifecycle/${encodeURIComponent(batchNo)}`,
    detail: (materialBatchNo: string | number) => `/api/v1/trace/material/${materialBatchNo}`,
    traceBatch: (batchNo: string | number) => `/api/v1/trace/batch/${batchNo}`,
    traceFull: (batchNo: string | number) => `/api/v1/trace/full/${batchNo}`,
    traceLifecycle: (batchNo: string | number) => `/api/v1/trace/lifecycle/${batchNo}`,
  },

  // ========== Training ==========
  training: {
    list: '/api/v1/training/types',
    types: '/api/v1/training/types',
    detail: (id: string | number) => `/api/v1/training/types/${id}`,
    trainingTypes: (id: string | number) => `/api/v1/training/types/${id}`,
    delete: (id: string | number) => `/api/v1/training/types/${id}`,
    toggleStatus: (id: string | number) => `/api/v1/training/types/${id}/toggle-status`,
    trainingTasks: (id: string | number) => `/api/v1/training/tasks/${id}`,
    tasks: '/api/v1/training/tasks',
    publish: (id: string | number) => `/api/v1/training/tasks/${id}/publish`,
    cancel: (id: string | number) => `/api/v1/training/tasks/${id}/cancel`,
    start: (id: string | number) => `/api/v1/training/tasks/${id}/start`,
    complete: (id: string | number) => `/api/v1/training/tasks/${id}/complete`,
    close: (id: string | number) => `/api/v1/training/tasks/${id}/close`,
    tasksSignInCode: (id: string | number) => `/api/v1/training/tasks/${id}/sign-in-code`,
    refreshSignInCode: (id: string | number) => `/api/v1/training/tasks/${id}/refresh-sign-in-code`,
    createMakeup: (id: string | number) => `/api/v1/training/tasks/${id}/create-makeup`,
    tasksMakeupRequired: (id: string | number) => `/api/v1/training/tasks/${id}/makeup-required`,
    tasksMakeupTasks: (id: string | number) => `/api/v1/training/tasks/${id}/makeup-tasks`,
    tasksParticipants: (taskId: string | number, participantId: string | number) => `/api/v1/training/tasks/${taskId}/participants/${participantId}`,
    participants: (taskId: string | number) => `/api/v1/training/tasks/${taskId}/participants`,
    addByDepartment: (taskId: string | number) => `/api/v1/training/tasks/${taskId}/participants/add-by-department`,
    batchMarkAttendance: (taskId: string | number) => `/api/v1/training/tasks/${taskId}/participants/batch-mark-attendance`,
    batchMarkMakeup: (taskId: string | number) => `/api/v1/training/tasks/${taskId}/participants/batch-mark-makeup`,
    markAttendance: (id: string | number) => `/api/v1/training/participants/${id}/mark-attendance`,
    markMakeup: (id: string | number) => `/api/v1/training/participants/${id}/mark-makeup`,
    myTasks: '/api/v1/training/my-tasks',
    trainingMyTasks: (id: string | number) => `/api/v1/training/my-tasks/${id}`,
    confirm: (id: string | number) => `/api/v1/training/my-tasks/${id}/confirm`,
    signIn: (id: string | number) => `/api/v1/training/my-tasks/${id}/sign-in`,
    myTasksComplete: (id: string | number) => `/api/v1/training/my-tasks/${id}/complete`,
    trainingMyRecords: '/api/v1/training/my-records',
    statisticsOverview: '/api/v1/training/statistics/overview',
    statisticsByDepartment: '/api/v1/training/statistics/by-department',
    statisticsByType: '/api/v1/training/statistics/by-type',
    statisticsByEmployee: '/api/v1/training/statistics/by-employee',
  },

  // ========== Tv ==========
  tv: {
    login: '/api/v1/tv/auth/login',
    verify: '/api/v1/tv/auth/verify',
    refresh: '/api/v1/tv/auth/refresh',
    dashboard: '/api/v1/tv/andon/dashboard',
    andonDashboardAlerts: '/api/v1/tv/andon/dashboard/alerts',
    list: '/api/v1/tv/config',
    productionDashboard: '/api/v1/tv/production/dashboard',
    dashboardShiftOutput: '/api/v1/tv/production/dashboard/shift-output',
    dashboardRecentReports: '/api/v1/tv/production/dashboard/recent-reports',
    dashboardOutputTrend: '/api/v1/tv/production/dashboard/output-trend',
    dashboardOperationProgress: '/api/v1/tv/production/dashboard/operation-progress',
    dashboardPlanProgress: '/api/v1/tv/production/dashboard/plan-progress',
    config: '/api/v1/tv/config',
    devices: '/api/v1/tv/devices',
    deviceDetail: (id: string | number) => `/api/v1/tv/devices/${id}`,
  },

  // ========== Upload ==========
  upload: {
    create: '/api/v1/upload',
  },

  // ========== User ==========
  user: {
    list: '/api/v1/users',
    create: '/api/v1/users',
    detail: (user: string | number) => `/api/v1/users/${user}`,
    users: (user: string | number) => `/api/v1/users/${user}`,
    delete: (user: string | number) => `/api/v1/users/${user}`,
  },

  // ========== Warehouse ==========
  warehouse: {
    list: '/api/v1/warehouses',
    all: '/api/v1/warehouses/all',
    create: '/api/v1/warehouses',
    detail: (id: string | number) => `/api/v1/warehouses/${id}`,
    warehouses: (id: string | number) => `/api/v1/warehouses/${id}`,
    delete: (id: string | number) => `/api/v1/warehouses/${id}`,
    batchDelete: '/api/v1/warehouses/batch-delete',
    import: '/api/v1/warehouses/import',
    order: '/api/v1/warehouses/order',
    statistics: (id: string | number) => `/api/v1/warehouses/${id}/statistics`,
    statisticsType: '/api/v1/warehouses/statistics/type',
    findByCode: (code: string | number) => `/api/v1/warehouses/code/${code}`,
    warehouseLocationsList: '/api/v1/warehouse-locations',
    warehouseLocations: (id: string | number) => `/api/v1/warehouse-locations/${id}`,
    warehouseLocationsAll: '/api/v1/warehouse-locations/all',
    warehouseLocationsBatchDelete: '/api/v1/warehouse-locations/batch-delete',
    warehouseLocationsImport: '/api/v1/warehouse-locations/import',
    warehouseLocationsOrder: '/api/v1/warehouse-locations/order',
    tree: (warehouseId: string | number) => `/api/v1/warehouse-locations/tree/${warehouseId}`,
    warehouseLocationsStatistics: (warehouseId: string | number) => `/api/v1/warehouse-locations/statistics/${warehouseId}`,
    code: (code: string | number) => `/api/v1/warehouse-locations/code/${code}`,
    findByBarcode: (barcode: string | number) => `/api/v1/warehouse-locations/barcode/${barcode}`,
    update: (id: string | number) => `/api/v1/warehouse-locations/${id}/capacity`,
  },

  // ========== Web Logs（Web 前端监控日志）==========
  // 📌 注意区分：
  // - webLogs：Web 管理后台前端的日志（浏览器端）
  // - appLogs：移动 App 端的日志（iOS/Android/小程序）
  webLogs: {
    /** 仪表盘统计 */
    dashboard: '/api/v1/web-logs/dashboard',
    /** Web 前端错误日志 - 批量上传/列表查询 */
    errors: '/api/v1/web-logs/errors',
    /** Web 前端错误统计 */
    errorsStatistics: '/api/v1/web-logs/errors/statistics',
    /** Web 前端性能日志 - 批量上传/列表查询 */
    performance: '/api/v1/web-logs/performance',
    /** Web 前端性能统计 */
    performanceStatistics: '/api/v1/web-logs/performance/statistics',
    /** 用户列表 */
    users: '/api/v1/web-logs/users',
    /** 用户画像 */
    userProfile: (userId: string | number) => `/api/v1/web-logs/users/${userId}/profile`,
    /** 用户时间线 */
    userTimeline: (userId: string | number) => `/api/v1/web-logs/users/${userId}/timeline`,
    /** API 统计 */
    apiStatistics: '/api/v1/web-logs/api/statistics',
    /** API 详情 */
    apiDetail: '/api/v1/web-logs/api/detail',
    /** 检测告警 */
    alertsDetect: '/api/v1/web-logs/alerts/detect',
    /** 告警汇总 */
    alertsSummary: '/api/v1/web-logs/alerts/summary',
    /** 行为日志列表/上传 */
    behavior: '/api/v1/web-logs/behavior',
    /** 行为统计 */
    behaviorStatistics: '/api/v1/web-logs/behavior/statistics',
    /** 热门页面 */
    behaviorHotPages: '/api/v1/web-logs/behavior/hot-pages',
    /** 模块使用统计 */
    behaviorModules: '/api/v1/web-logs/behavior/modules',
    /** 漏斗定义列表 */
    funnelList: '/api/v1/web-logs/funnel/list',
    /** 漏斗转化分析 */
    funnelAnalysis: '/api/v1/web-logs/funnel/analysis',
    /** 操作中断分析 */
    funnelInterruptions: '/api/v1/web-logs/funnel/interruptions',
    /** 漏斗定义 CRUD */
    funnel: '/api/v1/web-logs/funnel',
    /** 漏斗定义（按 ID） */
    funnelById: (id: string | number) => `/api/v1/web-logs/funnel/${id}`,
  },

  // ========== Wework ==========
  wework: {
    list: '/api/v1/wework/webhook',
    oauthCallback: '/api/v1/wework/oauth/callback',
    login: '/api/v1/wework/mobile/login',
    webhook: '/api/v1/wework/webhook',
    jsApiConfig: '/api/v1/wework/js-api-config',
    bind: '/api/v1/wework/bind',
    unbind: '/api/v1/wework/unbind',
  },

  // ========== DingTalk ==========
  dingtalk: {
    authConfig: '/api/v1/dingtalk/auth/config',
    authLogin: '/api/v1/dingtalk/auth/login',
    organizationSync: '/api/v1/dingtalk/organization/sync',
  },

  // ========== Workshop ==========
  workshop: {
    list: '/api/v1/workshops',
    all: '/api/v1/workshops/all',
    findByCode: '/api/v1/workshops/find-by-code',
    create: '/api/v1/workshops',
    batchDelete: '/api/v1/workshops/batch-delete',
    import: '/api/v1/workshops/import',
    order: '/api/v1/workshops/order',
    detail: (id: string | number) => `/api/v1/workshops/${id}`,
    workshops: (id: string | number) => `/api/v1/workshops/${id}`,
    delete: (id: string | number) => `/api/v1/workshops/${id}`,
    statistics: (id: string | number) => `/api/v1/workshops/${id}/statistics`,
    productionLines: (id: string | number) => `/api/v1/workshops/${id}/production-lines`,
  },

  // ========== Team 班组（生产结构：车间之下的作业单元） ==========
  team: {
    list: '/api/v1/teams',
    all: '/api/v1/teams/all',
    create: '/api/v1/teams',
    detail: (id: string | number) => `/api/v1/teams/${id}`,
    update: (id: string | number) => `/api/v1/teams/${id}`,
    updateStatus: (id: string | number) => `/api/v1/teams/${id}/status`,
    delete: (id: string | number) => `/api/v1/teams/${id}`,
  },

  // ========== Monitoring 监控配置 ==========
  monitoring: {
    /** 获取监控配置（公开接口，免鉴权） */
    config: '/api/v1/monitoring/config',
  },

  // ========== Workstation ==========
  workstation: {
    list: '/api/v1/workstations',
    all: '/api/v1/workstations/all',
    findByCode: '/api/v1/workstations/find-by-code',
    findByBarcode: (barcode: string | number) => `/api/v1/workstations/barcode/${barcode}`,
    create: '/api/v1/workstations',
    batchDelete: '/api/v1/workstations/batch-delete',
    import: '/api/v1/workstations/import',
    order: '/api/v1/workstations/order',
    detail: (id: string | number) => `/api/v1/workstations/${id}`,
    workstations: (id: string | number) => `/api/v1/workstations/${id}`,
    delete: (id: string | number) => `/api/v1/workstations/${id}`,
    update: (id: string | number) => `/api/v1/workstations/${id}/status`,
    assignOperator: (id: string | number) => `/api/v1/workstations/${id}/assign-operator`,
    clearOperator: (id: string | number) => `/api/v1/workstations/${id}/clear-operator`,
    calculateCapacity: (id: string | number) => `/api/v1/workstations/${id}/calculate-capacity`,
    qrCode: (id: string | number) => `/api/v1/workstations/${id}/qr-code`,
    statistics: (id: string | number) => `/api/v1/workstations/${id}/statistics`,
  },
} as const

// ========== 类型定义 ==========

/** v1 配置类型 */
export type ApiV1Config = typeof API_V1_CONFIG

/** v1 路由类型 */
export type ApiV1Routes = typeof API_V1_ROUTES
